import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, ChangeDetectorRef, EventEmitter, Output, Input } from '@angular/core';
import { CircularService } from 'src/app/shared/services/circular.service';
import { OptionKey } from 'src/app/shared/models/long-haul.model';
import { TranslateService } from '@ngx-translate/core';
import { CircularsFixedRebateOptions, CircularRequest, Circular, Regions, Percentages, StepDecision } from 'src/app/shared/models/circular.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { LookupService } from 'src/app/front-user/shared/services/lookup.service';
import { VesselType, CircularsVesselType } from 'src/app/front-user/shared/models/vessel-type.modal';
import { FormBuilder, FormGroup, FormArray, Validators,ValidatorFn, AbstractControl, ValidationErrors, FormControl } from '@angular/forms';
import { Country } from 'src/app/front-user/shared/models/country.model';
import { Port } from 'src/app/front-user/shared/models/port.model';
import { SailDirection } from 'src/app/front-user/shared/models/sail-direction.model';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { User } from 'src/app/front-user/shared/models/user.model';
import { GenericLookup } from 'src/app/front-user/shared/models/generic-lookup.model';
import { AppConfig } from 'src/app/shared/services/app.config';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { MainEngineFuel } from 'src/app/front-user/shared/models/main-fuel-engine';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { AgentService } from 'src/app/front-user/services/e-booking/shared/services/agent.service';
import { Status } from 'src/app/shared/models/general.model';
import { ErrorsEnum, ServiceStatus, Service, SCAWaterMark, Logo } from 'src/app/shared/models/enums.model';
import { CustomValidators } from 'src/app/front-user/shipyard-service/models/custom-validator';
import { DatePipe } from '@angular/common';
import * as pdfMake from 'pdfmake/build/pdfmake.min';
import pdfFonts from "pdfmake/build/vfs_fonts";
import { CookieService } from 'ngx-cookie-service';

pdfMake.vfs = pdfFonts?.pdfMake?.vfs;


@Component({
  selector: 'app-circular-request',
  templateUrl: './circular-request.component.html'
})

export class CircularRequestComponent implements OnInit, AfterViewInit {
  @ViewChild('pdfTable',{static: false}) pdfTable: ElementRef;
  private circularRequest: CircularRequest = new CircularRequest();
  private circularRequestObject;
  private submitRebateRequestResponseObject: ResponseObject = new ResponseObject();
  private ValidRequestData: ResponseObject = new ResponseObject();
  private validRebateRequest: CircularRequest = new CircularRequest();
  private yearBuiltMaxDate: Date = new Date(Date.now());
  private checkShipIMOValidRebateResponseObject: ResponseObject = new ResponseObject();
  //Lookup Properties
  SailingDateFormatted: string = "";
  ETAFormatted: string = "";
  public vesselTypes: CircularsVesselType[] = [];
  public vesselCircularsTypes: CircularsVesselType[] = [];
  public countries: GenericLookup[] = [];
  public circulars: Circular[] = [];

  private reltatedFileNo = "";
  public SelectedCircular: Circular;
  public SelectedDirection: number;
  public selectedIds;
  private noOfOptionsOfSameRoute: number = 0;
  private showImoWarning: Boolean = false;
  private vesselTypeChanged: Boolean = false;
  private showCargoWarning: Boolean = false;
  private showPDF: Boolean = false;
  private OriginshowDescription: Boolean = false;
  private DistshowDescription: Boolean = false;
  private originDescription: string = "";
  private distDescription: string = "";
  public FromRegions: Percentages[] = [];
  public ToRegions: Percentages[] = [];
  public TempToRegions: Percentages[] = [];
  public selectedPercenatge: Percentages[];
  public selecteddistPercenatge: Percentages[];
  private DistDuplicate: Boolean = false;
  private todayDate = new Date(new Date().setDate(new Date().getDate() + 1));
  public ports: Port[] = [];
  private agentFax: string = "";
  public GSCNT: string;
  private showURL: Boolean = false;
  private showSubmit: Boolean = false;
  public GSID: string;
  private lastPortsOrigin: Port[] = [];
  private firstPortsDestination: Port[] = [];
  public sailDirections: SailDirection[] = [];
  public mainEngineFuels: MainEngineFuel[] = [];
  private noOfLoadedLookups: number = 0;
  private noOfLoadingLookups: number = 5;
  private IsSelectedDirection: boolean = false;
  private IsSelectedCircular: boolean = false;
  private NoData: boolean = false;
  private cannoteditOrigin: boolean = false;
  public serviceStatus = ServiceStatus;

  //Form Properties
  public circularRequestForm: FormGroup;
  private isFormSubmitted: boolean = false;
  private isOptionSubmitted: boolean = false;
  private isOptionsValidatedFromSubmit: boolean = false;
  //Current User
  private currentUserEmail: string = "";
  private currentUserId: string = "";
  //Date Time Properties

  private dateOfSailing: Date = new Date(Date.now());
  //Rebate Request Options Properties
  private rebateRequestOptionsArrLength: number = 1;
  //Tabs
  @ViewChild('rebateRequestTabs',{static: false}) rebateRequestTabs: TabsetComponent;
  private isTabOneSubmitted: boolean = false;
  private isTabOneValid: boolean = false;
  private isTabTwoSubmitted: boolean = false;
  private isTabTwoValid: boolean = false;
  private isOptionsArrValid: boolean = false;
  @ViewChild('tabOne',{static: false}) tabOneControls: ElementRef;
  @ViewChild('tabTwo',{static: false}) tabTwoControls: ElementRef;
  @ViewChild('tabTwoPrincipal',{static: false}) tabTwoPrincipalControls: ElementRef;
  @ViewChild('options',{static: false}) optionsControls: ElementRef;

  public currentUser: User = new User();
  //Options GridView Properties
  private lastCountryOriginsArr: OptionKey[] = [];
  private OriginsArr: OptionKey[] = [];
  private distinationArr: OptionKey[] = [];
  private firstCountryDestinationsArr: OptionKey[] = [];
  private lastPortOriginsArr: OptionKey[] = [];
  private firstPortDestinationsArr: OptionKey[] = [];
  private isOptionEdited: boolean = false;
  private editedOptionIndex: number = -1;
  private StepOpject: StepDecision;
  public isFormValid: boolean = false;
  private confirmationMessage: string = "";

  public formMode: FormMode = FormMode.New;
  public ParentRequestLoaded: CircularRequest = new CircularRequest();
  private rebateRequestId: string = "";
  private ActivityInstanceID: string = "";
  public rebateRequestLoaded: CircularRequest = new CircularRequest();
  private getRebateRequestResponseObject: ResponseObject = new ResponseObject();

  public showOptionDev: boolean = false;
  public editModeAdmin: boolean = false;
  public showClone: boolean = true;
  //Event Properties
  public Percentages: Percentages[] = [];
  @Output() rebateRequestLoadedFlag: EventEmitter<boolean> = new EventEmitter();
  //Require Modification Notes
  public isRequireModificationNotesExist: boolean = false;
  public isRejectionReasonNotesExist: boolean = false;
  public requireModificationNotes: string = "";
  //Check IMO
  private rebateRequestCreationDate;
  private requestHasValidIMORebate: boolean = false;
  private noOfDeletedOptions: number = 0;
  private isOptionsHeadersEnabled: boolean = true;
  public ParentCreationDateForSubRequest;
  //Clone Request
  public isCloneComponent: boolean = false;
  public selectedVesselTypeID : number = 0;
  private isRequestDetailsComponent: boolean = false;
  private clonedComponentDirectionId;
  private clonedComponentCircularId;
  //Date Compare
  private isDateOfSailingGTETA: boolean = false;
  private isETASCGTETAD: boolean = false;
  private selectedOption : number = 0;
  private noOfOptionsToBeDeletedGlobal: number = 0;

  private requestTimeBeforeSailingDate: number = 0;
  public submitConfirmationMode: ConfirmationMode = ConfirmationMode.Success;
  public insideCancelationComponents: boolean;
  //#endregion

  //#region Constructor
  constructor(private cookieService: CookieService,private agentSrv: AgentService,private translate: TranslateService,public datepipe: DatePipe, private circularService: CircularService, private lookupService: LookupService, private formBuilder: FormBuilder, private cd: ChangeDetectorRef, private router: ActivatedRoute, private globalServices: GlobalServices, private route: Router, private authenticationService: AuthenticationService) {
    this.currentUser = this.authenticationService.currentUserValue;
    if (!this.currentUser.IsAdmin && this.currentUser.RegisterTypeId == 3) {
      this.route.navigate(['/unAuhtorized']);
    } else {
      // Open Component Using Id [History / Local Storage]
      let currentUrl: string = window.location.href;
      let lastPartUrl: string = currentUrl.substr(currentUrl.lastIndexOf('/') + 1);
      if (history.state.data && history.state.data.requestId) {
        this.rebateRequestId = history.state.data.requestId;
        if (history.state.data.ActivityInstanceID) {
          this.ActivityInstanceID = history.state.data.ActivityInstanceID;
        }
      } else if (localStorage.getItem('lsRebateRequestId') != undefined) {
        this.rebateRequestId = localStorage.getItem('lsRebateRequestId');
        localStorage.removeItem('lsRebateRequestId');
      } else if (lastPartUrl != "CircularRequest") {
        window.history.back();
      }
      //Check Clone Request Component
      if (lastPartUrl === "CloneRequest") {
        this.isCloneComponent = true;
        this.showPDF = false;
        this.showClone = false;
      }
      //Check Rebate Request - Request Details => Edit Mode
      if (lastPartUrl === "RequestDetails")
        this.isRequestDetailsComponent = true;

    }
  }

  ngOnInit() {

    this.globalServices.isLoaderEnabled = true;
    this.loadLookups();
    this.buildForm();

  }
  getAgentOnly(requestorId) {
    this.agentSrv.GetAgentOnly(requestorId).subscribe(d => {
      if (d.Success) {

        this.agentFax = d.Data.Fax;
      }
    });}

  ngAfterViewInit() {

    this.setDefaults();
  }

  loadLookups(): void {
    this.loadCircularVesselTypes();
    this.loadCountries();

    this.loadSailDirections();
    this.loadMainEngineFuels();

  }

  loadCirculars(): void {
    this.lookupService.getCirculars().subscribe(
      data => this.circulars = data.Data as Circular[],
      () => console.log("Something went wrong!!"),
    );
  }

  loadMainEngineFuels(): void {
    this.lookupService.getMainEngineFuels().subscribe(
      data => this.mainEngineFuels = data.Data as MainEngineFuel[],
      () => console.log("Something went wrong!!"),
      () => this.loadMainEngineFuelsCompleted()
    );
  }
  loadVesselTypes(): void {
    this.lookupService.getVesselTypes().subscribe(
      data => this.vesselTypes = data.Data as CircularsVesselType[],
      () => console.log("Something went wrong!!"),
      () => this.loadCircularVesselTypesCompleted()
    );
  }

  loadCircularVesselTypes(): void {
    this.lookupService.getCircularsVesselTypes().subscribe(
      data => this.vesselTypes = data.Data as CircularsVesselType[],
      () => console.log("Something went wrong!!"),
      () => this.loadCircularVesselTypesCompleted()
    );
  }
  goToCircularDetails(): void {
    window.open(this.SelectedCircular.URL, '_blank');
  }


  loadCircularVesselTypesCompleted(): void {
    var unique = [];
    var distinct = [];
    for (let i = 0; i < this.vesselTypes.length; i++) {
      if (!unique[this.vesselTypes[i].NameEN]) {
        distinct.push(this.vesselTypes[i]);
        unique[this.vesselTypes[i].NameEN] = 1;
      }
    }
    this.vesselCircularsTypes = distinct as CircularsVesselType[];
    this.checkLoadedLookups();
  }
  loadMainEngineFuelsCompleted(): void {
    this.mainEngineFuels.sort((a, b) => (a.Fuel > b.Fuel) ? 1 : -1);
    this.checkLoadedLookups();
  }
  getRequiredModifications(): void {
    this.circularService.getFirstDecision(this.rebateRequestLoaded.Id).subscribe(
      data => this.StepOpject = data.Data as StepDecision,
      () => console.log("Something went wrong!!"),
      () => this.loadRequiredModificationsCompleted()
    );
  }
  loadRequiredModificationsCompleted() {
    this.requireModificationNotes = this.StepOpject.comment;
  }

  loadCountries(): void {
    this.lookupService.getCountries().subscribe(
      data => this.countries = data.Data as Country[],
      () => console.log("Something went wrong!!"),
      () => this.loadCountriesCompleted()
    );
  }
  /*loadCirculars(): void {
    this.lookupService.getCirculars().subscribe(
      data => this.circulars = data.Data as Circular[],
      () => console.log("Something went wrong!!"),
    );
  }*/
  /*loadRegionsByCircularId(CircularId): void {
    this.lookupService.GetRegionsByCircularID(CircularId).subscribe(
      data => this.FromRegions = data.Data as Regions[],
      () => console.log("Something went wrong!!"),
    );
  }*/
  loadRegionsByOroginIdinDetails(id, directionId): void {
    this.circularService.GetPercentageByDirectionAndCircularIdWithDeleted(id, directionId).subscribe(
      data => this.FromRegions = data.Data as Percentages[],
      () => console.log("Something went wrong!!"),
      () => this.loadOriginCompleted()
    );
  }
  loadRegionsByOroginIdandCircularIDremainingdata(id, directionId): void {

    this.circularService.GetPercentageByDirectionAndCircularIdWithDeleted(id, directionId).subscribe(
      data => this.TempToRegions = data.Data as Percentages[],
      () => console.log("Something went wrong!!"),
      () => this.loadremainingDataComplated()
    );
  }
  loadremainingDataComplated(){

    this.TempToRegions.forEach((element, index) => {
      if (!element.CircularsRegions1) {
        delete this.TempToRegions[index];
        this.TempToRegions.splice(index, 1);
      }
    });
    this.Percentages = this.TempToRegions;
    this.ToRegions = this.TempToRegions;

    if (this.FromRegions.length === 0) {
      this.NoData = true;
      this.circularRequestForm.controls['TabTwo'].get('OriginRegionId').disable();
    }
    else {
      this.NoData = false;
      this.OriginshowDescription = false;

      //this.circularRequestForm.controls['TabTwo'].get('OriginRegionId').enable();
    }

    //this.ToRegions = this.FromRegions;
    this.selectedPercenatge = this.FromRegions.filter((obj) => {
      return obj.CircularsRegions.ID == this.rebateRequestLoaded.CircularsFixedRebateOptions[0].FromRegionId;
    });

    /*this.ToRegions = this.FromRegions.filter((obj) => {
      return obj.CircularsRegions.ID == this.rebateRequestLoaded.CircularsFixedRebateOptions[0].FromRegionId;
    });*/
   // this.loadRegionsByOroginIdandCircularID(this.selectedPercenatge[0].CircularsRegions.ID, this.rebateRequestLoaded.CircularsLookupId, this.rebateRequestLoaded.DateOfSailing, this.rebateRequestLoaded.ETASC)
    this.fillcircularRequestObject();


    this.SelectedDirection = this.rebateRequestLoaded.CircularsFixedRebateOptions[0].SailDirectionId;
    //this.SelectedCircular.Id = this.rebateRequestLoaded.CircularsLookupId;
    this.IsSelectedCircular = true;
    this.IsSelectedDirection = true;
    this.GSCNT = this.rebateRequestLoaded.SCNT;
    this.GSID = this.rebateRequestLoaded.SCID;



    this.showSubmit = true;
    if (this.rebateRequestLoaded.BaseRequest.StatusId == ServiceStatus.Circulars_Rejected) {
      this.isRejectionReasonNotesExist = true;
      this.getRequiredModifications();
    }
    if (this.rebateRequestLoaded.BaseRequest.StatusId == ServiceStatus.Circulars_MoreInformationRequestedFromAgent || this.rebateRequestLoaded.BaseRequest.StatusId == ServiceStatus.Circulars_NewRequest_ModifiedbyRequester) {
      this.isRequireModificationNotesExist = true;
      //this.showSubmit= true;
      this.getRequiredModifications();
    }

    this.rebateRequestLoadedFlag.emit(true);

    if (this.rebateRequestTabs.tabs[1] != undefined) {
      this.rebateRequestTabs.tabs[1].disabled = false;
      this.cd.detectChanges();
    }

    //Default => Form Mode = New Mode

    if (this.rebateRequestLoaded.IsEditable) {
      //Case: Admin Open Component & Component is Edit Mode
      if (window.location.href.indexOf('/CircularRequest/FirstStep') > -1 || window.location.href.indexOf('CircularRequest/SecondStep') > -1 || this.currentUser.IsAdmin) {
        //Details Mode
        this.formMode = FormMode.Details;
        //Disable Form Controls
        this.circularRequestForm.disable();
        this.circularRequestForm.controls['TabTwo'].get('ETASC').disable();
        this.circularRequestForm.controls['TabTwo'].get('DateOfSailing').disable();
        this.circularRequestForm.controls['TabTwo'].get('ETD').disable();

      } else {
        //Edit Mode
        this.formMode = FormMode.Edit;
        this.showOptionDev = true;
        this.circularRequestForm.controls['TabTwo'].get('CircularsLookupId').disable();
        this.circularRequestForm.controls['TabTwo'].get('SailDirectionId').disable();
        this.circularRequestForm.controls['TabTwo'].get('OriginRegionId').disable();
      }
    } else {
      //Clone Request
      this.circularRequestForm.controls['TabTwo'].get('CircularsLookupId').disable();
      if (this.rebateRequestLoaded.CanClone && this.isCloneComponent) {
        //Edit Mode
        this.formMode = FormMode.Edit;

        this.showOptionDev = true;
      }
      //Actual Details Mode
      else {
        //Details Mode
        this.formMode = FormMode.Details;
        //Disable Form Controls
        this.circularRequestForm.disable();
      }
    }
    const el = document.getElementsByClassName('sectionTitle');
    el[0].scrollIntoView({ behavior: 'smooth' });
    this.globalServices.isLoaderEnabled = false;

    }


  loadRegionsByOroginIdandCircularID(originID, CircularID, SailingDateFormatted, ETAFormatted): void {
    this.circularService.GetPercentageByFromRegionIdandCircularID(originID, CircularID, SailingDateFormatted, ETAFormatted).subscribe(
      data => this.TempToRegions = data.Data as Percentages[],
      () => console.log("Something went wrong!!"),
      () => this.loadDistnationCompleted()
    );
  }
  loadRegionsByOroginIdandCircularIDindetails(originID, CircularID, SailingDateFormatted, ETAFormatted): void {
    //here
    this.circularService.GetPercentageByFromRegionIdandCircularID(originID, CircularID, SailingDateFormatted, ETAFormatted).subscribe(
      data => this.TempToRegions = data.Data as Percentages[],
      () => console.log("Something went wrong!!"),
      () => this.loadDistnationCompletedinDetails()
    );
  }
  loadDistnationCompletedinDetails(): void {
    this.TempToRegions.forEach((element, index) => {
      if (!element.CircularsRegions1) {
        delete this.TempToRegions[index];
        this.TempToRegions.splice(index, 1);
      }
    });
    this.ToRegions = this.TempToRegions;

    var unique = [];
    var distinct = [];
    for (let i = 0; i < this.FromRegions.length; i++) {
      if (!unique[this.FromRegions[i].FromRegionId]) {
        distinct.push(this.FromRegions[i]);
        unique[this.FromRegions[i].FromRegionId] = 1;
      }
    }
    this.FromRegions = distinct as Percentages[];
    if (this.FromRegions.length === 0) {
      this.NoData = true;
      this.circularRequestForm.controls['TabTwo'].get('OriginRegionId').disable();
    }
    else {
      this.NoData = false;
      this.OriginshowDescription = false;
    }


    //this.ToRegions = this.FromRegions;
    this.selectedPercenatge = this.FromRegions.filter((obj) => {
      return obj.CircularsRegions.ID == this.rebateRequestLoaded.CircularsFixedRebateOptions[0].FromRegionId;
    });

    /*this.ToRegions = this.FromRegions.filter((obj) => {
      return obj.CircularsRegions.ID == this.rebateRequestLoaded.CircularsFixedRebateOptions[0].FromRegionId;
    });*/
    this.fillcircularRequestObject();


    this.SelectedDirection = this.rebateRequestLoaded.CircularsFixedRebateOptions[0].SailDirectionId;
    //this.SelectedCircular.Id = this.rebateRequestLoaded.CircularsLookupId;
    this.IsSelectedCircular = true;
    this.IsSelectedDirection = true;
    this.GSCNT = this.rebateRequestLoaded.SCNT;
    this.GSID = this.rebateRequestLoaded.SCID;



    this.showSubmit = true;
    if (this.rebateRequestLoaded.BaseRequest.StatusId == ServiceStatus.Circulars_Rejected) {
      this.isRejectionReasonNotesExist = true;
      this.getRequiredModifications();
    }
    if (this.rebateRequestLoaded.BaseRequest.StatusId == ServiceStatus.Circulars_MoreInformationRequestedFromAgent || this.rebateRequestLoaded.BaseRequest.StatusId == ServiceStatus.Circulars_NewRequest_ModifiedbyRequester) {
      this.isRequireModificationNotesExist = true;
      //this.showSubmit= true;
      this.getRequiredModifications();
    }

    this.rebateRequestLoadedFlag.emit(true);

    if (this.rebateRequestTabs.tabs[1] != undefined) {
      this.rebateRequestTabs.tabs[1].disabled = false;
      this.cd.detectChanges();
    }


    //Default => Form Mode = New Mode
    if (this.rebateRequestLoaded.IsEditable) {
      //Case: Admin Open Component & Component is Edit Mode
      if (window.location.href.indexOf('/CircularRequest/FirstStep') > -1 || window.location.href.indexOf('CircularRequest/SecondStep') > -1 || this.currentUser.IsAdmin) {
        //Details Mode
        this.formMode = FormMode.Details;
        //Disable Form Controls
        this.circularRequestForm.disable();
        this.circularRequestForm.controls['TabTwo'].get('ETASC').disable();
        this.circularRequestForm.controls['TabTwo'].get('DateOfSailing').disable();
        this.circularRequestForm.controls['TabTwo'].get('ETD').disable();

      } else {
        //Edit Mode
        this.formMode = FormMode.Edit;
        this.showOptionDev = true;
        this.circularRequestForm.controls['TabTwo'].get('CircularsLookupId').disable();
        this.circularRequestForm.controls['TabTwo'].get('SailDirectionId').disable();
        this.circularRequestForm.controls['TabTwo'].get('OriginRegionId').disable();
      }
    } else {
      //Clone Request
      this.circularRequestForm.controls['TabTwo'].get('CircularsLookupId').disable();
      if (this.rebateRequestLoaded.CanClone && this.isCloneComponent) {
        //Edit Mode
        this.formMode = FormMode.Edit;

        this.showOptionDev = true;
      }
      //Actual Details Mode
      else {
        //Details Mode
        this.formMode = FormMode.Details;
        //Disable Form Controls
        this.circularRequestForm.disable();
      }
    }
    const el = document.getElementsByClassName('sectionTitle');
    el[0].scrollIntoView({ behavior: 'smooth' });
    this.globalServices.isLoaderEnabled = false;
  }
  loadDistnationCompleted(): void {

    this.TempToRegions.forEach((element, index) => {
      if (!element.CircularsRegions1) {
        delete this.TempToRegions[index];
        this.TempToRegions.splice(index, 1);
      }
    });
    this.ToRegions = this.TempToRegions;

  }
  loadOriginCompleted(): void {


    if (this.rebateRequestLoaded.BaseRequest.StatusId == ServiceStatus.Circulars_MoreInformationRequestedFromAgent || this.rebateRequestLoaded.BaseRequest.StatusId == ServiceStatus.Circulars_NewRequest || this.rebateRequestLoaded.BaseRequest.StatusId == ServiceStatus.Circulars_NewRequest_EditedbyUser || this.rebateRequestLoaded.BaseRequest.StatusId == ServiceStatus.Circulars_NewRequest_ModifiedbyRequester)
    {
      this.LoadFromRegionss(this.rebateRequestLoaded.CircularsLookupId, this.rebateRequestLoaded.CircularsFixedRebateOptions[0].SailDirectionId, this.rebateRequestLoaded.DateOfSailing, this.rebateRequestLoaded.ETASC);
      this.circularRequestForm.controls['TabTwo'].get('OriginRegionId').disable();
      this.circularRequestForm.controls['TabTwo'].get('ETASC').disable();
      this.circularRequestForm.controls['TabTwo'].get('ETD').disable();
      this.circularRequestForm.controls['TabTwo'].get('DateOfSailing').disable();
      //this.loadRegionsByOroginIdandCircularID(this.rebateRequestLoaded.CircularsFixedRebateOptions[0].FromRegionId, this.rebateRequestLoaded.CircularsLookupId, this.rebateRequestLoaded.DateOfSailing, this.rebateRequestLoaded.ETASC)
    }
    else if (this.isCloneComponent)
    {
      this.LoadFromRegionss(this.rebateRequestLoaded.CircularsLookupId, this.rebateRequestLoaded.CircularsFixedRebateOptions[0].SailDirectionId, this.rebateRequestLoaded.DateOfSailing, this.rebateRequestLoaded.ETASC);
    }
    else
    {
        this.loadremainingData();
    }
  }

  loadremainingData(){
    this.loadRegionsByOroginIdandCircularIDremainingdata(this.rebateRequestLoaded.CircularsLookupId, this.rebateRequestLoaded.CircularsFixedRebateOptions[0].SailDirectionId);
  }
   SailingdateValidator(): ValidatorFn {

        return (control: AbstractControl): { [key: string]: boolean } | null => {

          if (this.selectedVesselTypeID == 31) {
            return null;
          } else {
            var date = new Date();
            var year = date.getFullYear();
            var month = date.getMonth()
            var day = date.getUTCDate();
            var todayDate = new Date(year, month, day);
            var enteredValue = control.value;
            var enteredDate = new Date(enteredValue);
            var dateString = enteredDate.toLocaleString('en-US').split(',')[0]
            var enteredDateByUser = new Date(dateString);
            if (enteredDateByUser < new Date(todayDate.toLocaleString('en-US'))) {
              return { inValidSailingDateError: true };
            }
            return null;
          }
        }

      }

  onVesseTypeChange(value: number): void {

    this.selectedVesselTypeID = value;
    this.circularRequestForm.controls['TabTwo'].get('ETD').setValue('');
    this.circularRequestForm.controls['TabTwo'].get('ETASC').setValue('');
    this.circularRequestForm.controls['TabTwo'].get('DateOfSailing').setValue('');
    this.circularRequestForm.controls['TabTwo'].get('CircularsLookupId').disable();
    this.vesselTypeChanged=true;
    this.IsSelectedCircular = false;
    let all = this.vesselTypes.filter((obj) => {
      return obj.VesselTypeId == value;
    });

    let selectedIds = all.map(({ CircularsLookupID }) => CircularsLookupID);
    this.selectedIds = selectedIds;
    this.loadFilteredCirculars(selectedIds)
    // here
    this.FromRegions = [];
    this.ToRegions = [];

    this.circularRequestForm.controls['TabTwo'].get('SailDirectionId').setValue('');
    this.circularRequestForm.controls['TabTwo'].get('ETD').enable();
    this.circularRequestForm.controls['TabTwo'].get('ETASC').enable();
    this.circularRequestForm.controls['TabTwo'].get('DateOfSailing').enable();
    this.circularRequestForm.controls['TabTwo'].get('SailDirectionId').enable();
    this.circularRequestForm.controls['TabTwo'].get('OriginRegionId').disable();
    this.circularRequestForm.controls['TabTwo'].get('CircularsLookupId').disable();





    if ((<FormArray>this.circularRequestForm.controls['TabTwo'].get('Options').value).length > 0) {

      const optionsArray = <FormArray>this.circularRequestForm.controls['TabTwo'].get('Options');

      //Remove Headers if One Option Exists
      let noOfOptionsToBeDeleted: number = 0
      for (let i: number = 0; i < (<FormArray>this.circularRequestForm.controls['TabTwo'].get('Options').value).length - 1; i++) {
        optionsArray.controls[i].patchValue({
          IsOptionDeleted: true
        });
        let option = (<FormArray>this.circularRequestForm.controls['TabTwo'].get('Options')).controls[i];
        if (option.value["IsOptionDeleted"])
          noOfOptionsToBeDeleted++;
      }
      // this.OriginsArr = [];
      // this.distinationArr = [];
      //this.circularRequestForm.controls['TabTwo'].value['Options'].setValue([])
      // (<FormArray>this.circularRequestForm.controls['TabTwo'].get('Options')).setValue([]);
      this.showSubmit = false;
      this.isOptionsHeadersEnabled = false;
      this.cannoteditOrigin = false;
      this.circularRequestForm.controls['TabTwo'].get('OriginRegionId').disable();
      //this.circularRequestForm.controls['TabTwo'].get('CircularsLookupId').disable();
    }


  }

  /*loadValidCirculars(selectedIds,ETA,dateOfSailing): void {
    this.lookupService.GetFilteredCirculars(selectedIds,ETA,dateOfSailing,).subscribe(
      data => this.circulars = data.Data as Circular[],
      () => console.log("Something went wrong!!"),
    );
  }*/
  loadValidCirculars(selectedIds, ETA, dateOfSailing): void {


    //this.circulars = [];
    //this.FromRegions = [];
    selectedIds.join(',');
    this.lookupService.GetFilteredCirculars(selectedIds, ETA, dateOfSailing).subscribe(
      data => this.circulars = data.Data as Circular[],
      () => console.log("Something went wrong!!"),
      () => this.loadValidCircularsCompleted()
    );
  }
  loadFilteredCirculars(selectedIds): void {

    this.lookupService.GetCircularsByIds(selectedIds).subscribe(
      data => this.circulars = data.Data as Circular[],
      () => console.log("Something went wrong!!"),

    );
  }
  loadValidCircularsCompleted(): void {

    if(this.vesselTypeChanged){
      this.circularRequestForm.controls['TabTwo'].get('CircularsLookupId').enable();
    }
    else
    {
      if(this.circularRequestForm.controls['TabTwo'].value['Options'].length>1){
        this.circularRequestForm.controls['TabTwo'].get('CircularsLookupId').disable();
      }
      else
      {
        this.circularRequestForm.controls['TabTwo'].get('CircularsLookupId').enable();
      }
    }


  }

  loadCountriesCompleted(): void {
    this.countries.sort((a, b) => (a.NameEN > b.NameEN) ? 1 : -1);
    this.loadPorts();
    this.checkLoadedLookups();
  }
  loadPorts(): void {

    this.lookupService.getPorts().subscribe(
      data => this.ports = data.Data as Port[],
      () => console.log("Something went wrong!!"),
      () => this.loadPortsCompleted()
    );
  }
  LoadFromRegionsinDetails(CircularId: number, SelectedDirectionid: number): void {
    this.circularService.GetPercentageByDirectionAndCircularIdWithDeleted(CircularId, SelectedDirectionid).subscribe(
      data => this.FromRegions = data.Data as Percentages[],
      () => console.log("Something went wrong!!"),
      () => this.LoadFromRegionsinDetailsCompleted()
    );
  }
  LoadFromRegionsinDetailsCompleted(): void {
    if (this.rebateRequestLoaded.BaseRequest.StatusId == ServiceStatus.Circulars_MoreInformationRequestedFromAgent || this.rebateRequestLoaded.BaseRequest.StatusId == ServiceStatus.Circulars_NewRequest || this.rebateRequestLoaded.BaseRequest.StatusId == ServiceStatus.Circulars_NewRequest_EditedbyUser || this.rebateRequestLoaded.BaseRequest.StatusId == ServiceStatus.Circulars_NewRequest_ModifiedbyRequester)
    {
      this.LoadFromRegionss(this.rebateRequestLoaded.CircularsLookupId, this.rebateRequestLoaded.CircularsFixedRebateOptions[0].SailDirectionId, this.rebateRequestLoaded.DateOfSailing, this.rebateRequestLoaded.ETASC);
      this.circularRequestForm.controls['TabTwo'].get('OriginRegionId').disable();
      this.circularRequestForm.controls['TabTwo'].get('ETASC').disable();
      this.circularRequestForm.controls['TabTwo'].get('ETD').disable();
      this.circularRequestForm.controls['TabTwo'].get('DateOfSailing').disable();
      //this.loadRegionsByOroginIdandCircularID(this.rebateRequestLoaded.CircularsFixedRebateOptions[0].FromRegionId, this.rebateRequestLoaded.CircularsLookupId, this.rebateRequestLoaded.DateOfSailing, this.rebateRequestLoaded.ETASC)
    }
    else if (this.isCloneComponent)
    {
      this.LoadFromRegionss(this.rebateRequestLoaded.CircularsLookupId, this.rebateRequestLoaded.CircularsFixedRebateOptions[0].SailDirectionId, this.rebateRequestLoaded.DateOfSailing, this.rebateRequestLoaded.ETASC);
    }
    else
    {
        this.loadremainingData();
    }
   // this.loadRegionsByOroginIdinDetails(this.rebateRequestLoaded.CircularsLookupId, this.rebateRequestLoaded.CircularsFixedRebateOptions[0].SailDirectionId);
  }

  LoadFromRegions(CircularId: number, SelectedDirectionid: number, dateOfSailing, ETA): void {
    this.circularService.GetPercentagesFiltered(CircularId, SelectedDirectionid, dateOfSailing, ETA).subscribe(
      data => this.FromRegions = data.Data as Percentages[],
      () => console.log("Something went wrong!!"),
      () => this.LoadFromRegionsCompleted()
    );
  }
  LoadFromRegionss(CircularId: number, SelectedDirectionid: number, dateOfSailing, ETA): void {
    this.circularService.GetPercentagesFiltered(CircularId, SelectedDirectionid, dateOfSailing, ETA).subscribe(
      data => this.FromRegions = data.Data as Percentages[],
      () => console.log("Something went wrong!!"),
      () => this.LoadFromRegionssCompleted()
    );
  }

  LoadFromRegionssCompleted(): void {

    this.loadRegionsByOroginIdandCircularIDindetails(this.rebateRequestLoaded.CircularsFixedRebateOptions[0].FromRegionId, this.rebateRequestLoaded.CircularsLookupId, this.rebateRequestLoaded.DateOfSailing, this.rebateRequestLoaded.ETASC)
  }
  LoadFromRegionsCompleted(): void {
    var unique = [];
    var distinct = [];
    for (let i = 0; i < this.FromRegions.length; i++) {
      if (!unique[this.FromRegions[i].FromRegionId]) {
        distinct.push(this.FromRegions[i]);
        unique[this.FromRegions[i].FromRegionId] = 1;
      }
    }
    this.FromRegions = distinct as Percentages[];
    if (this.FromRegions.length === 0) {
      this.NoData = true;
      this.circularRequestForm.controls['TabTwo'].get('OriginRegionId').disable();
    }
    else {
      this.NoData = false;
      this.OriginshowDescription = false;
    }
  }
  enableOriginRegion(): void {

    if (this.IsSelectedDirection && this.IsSelectedCircular) {
      this.circularRequestForm.controls['TabTwo'].get('OriginRegionId').enable();
      this.LoadFromRegions(this.circularRequestForm.controls['TabTwo'].get('CircularsLookupId').value, this.SelectedDirection, this.SailingDateFormatted, this.ETAFormatted);
    }
    else {
      this.circularRequestForm.controls['TabTwo'].get('OriginRegionId').disable();
      this.FromRegions = [];
      this.ToRegions = [];
      this.DistshowDescription = false;
      this.OriginshowDescription = false;
      const optionsArray = <FormArray>this.circularRequestForm.controls['TabTwo'].get('Options');
      optionsArray.controls[optionsArray.length - 1].get('CircularsPercentagesId').setValue('');
    }
  }
  onDirectionSelect(directionID: number): void {

    if (directionID) {
      const optionsArray = <FormArray>this.circularRequestForm.controls['TabTwo'].get('Options');
      optionsArray.controls[optionsArray.length - 1].get('CircularsPercentagesId').setValue('');
      this.ToRegions = [];
      this.circularRequestForm.controls['TabTwo'].get('OriginRegionId').setValue('');
      this.OriginshowDescription = false;
      this.DistshowDescription = false;
      this.SelectedDirection = directionID;
      this.IsSelectedDirection = true;
      this.enableOriginRegion()
    }
    else {
      this.IsSelectedDirection = false;
      this.enableOriginRegion()
      this.NoData = false;
      this.OriginshowDescription = false;
      this.circularRequestForm.controls['TabTwo'].get('OriginRegionId').disable();
      const optionsArray = <FormArray>this.circularRequestForm.controls['TabTwo'].get('Options');
      optionsArray.controls[optionsArray.length - 1].get('CircularsPercentagesId').setValue('');
    }
  }
  onCircularLookupSelect(CircularId: number): void {
    if (CircularId) {
      this.circularRequestForm.controls['TabTwo'].get('OriginRegionId').setValue('');
      this.SelectedCircular = this.circulars.find((obj) => {
        return obj.Id == CircularId;
      });
      if (this.SelectedCircular != undefined) {
        this.showURL = true;
        this.IsSelectedCircular = true;
        this.enableOriginRegion()
        this.getRequestTimeBeforeSailingDate(this.SelectedCircular.ExpirationdependsOnETA);
        this.circularRequestForm.controls['TabTwo'].get('OriginRegionId').enable;
      }
      else {
        this.IsSelectedCircular = false;
        this.enableOriginRegion()
      }
      const optionsArray = <FormArray>this.circularRequestForm.controls['TabTwo'].get('Options');
      optionsArray.controls[optionsArray.length - 1].get('CircularsPercentagesId').setValue('');
      this.ToRegions = [];
      this.OriginshowDescription = false;
      this.DistshowDescription = false;
      this.DistDuplicate = false;
    }
    else {
      this.showURL = false;
      this.IsSelectedCircular = false;
      this.NoData = false;
      this.OriginshowDescription = false;
      this.DistshowDescription = false;
      this.DistDuplicate = false;
      this.FromRegions = [];
      this.ToRegions = [];
      this.circularRequestForm.controls['TabTwo'].get('OriginRegionId').disable();
      const optionsArray = <FormArray>this.circularRequestForm.controls['TabTwo'].get('Options');
      optionsArray.controls[optionsArray.length - 1].get('CircularsPercentagesId').setValue('');
    }
  }

  goToTermsAndConditions(): void {
    window.open(AppConfig.settings.apiServer.CircularsTermsEN, '_blank');
  }

  ondistSelect(distId: number): void {
    this.noOfOptionsOfSameRoute = 0;
    this.DistDuplicate = false;
    if (distId) {
      this.selecteddistPercenatge = this.ToRegions.filter((obj) => {
        return obj.Id == distId;
      });
      this.distDescription = this.selecteddistPercenatge[0].CircularsRegions1.Description;
      this.DistshowDescription = true;
      const optionsArray = <FormArray>this.circularRequestForm.controls['TabTwo'].get('Options');
      for (let i: number = 0; i < (optionsArray.value).length - 1; i++) {
        let option = (optionsArray).controls[i];
        if (option.value["CircularsPercentagesId"] == distId && !option.value["IsOptionDeleted"]) {
          this.noOfOptionsOfSameRoute++;
          if (this.noOfOptionsOfSameRoute >= 1) {
            if(this.selectedOption== distId){
              this.DistDuplicate = false;
              this.DistshowDescription = true;
            }else
            {
              this.DistDuplicate = true;
            this.DistshowDescription = false;
            }

          }
          else {
            this.DistDuplicate = false;
            this.DistshowDescription = true;
          }
        }

      }
    }
    else {
      this.DistshowDescription = false;
    }

  }
  onImoChange(value: String): void {

    if (value.length >= 7) {
      this.circularService.GetValidRequests(value, this.currentUser.UserName).subscribe(
        data => this.ValidRequestData = data,
        () => console.log("Something went wrong!!"),
        () => this.onImoChangeCheckCompleted()
      );
    }
    else {
      this.showImoWarning = false;
    }

  }
  onImoChangeCheckCompleted() {
    if (this.ValidRequestData.Success) {
      if (this.ValidRequestData.Data[0] != null) {
        this.reltatedFileNo = this.ValidRequestData.Data[0];
        this.showImoWarning = true;
      }
      else {
        this.showImoWarning = false;
      }
    }
    else {
      this.showImoWarning = false;
    }
  }
  onOriginSelect(oroginId: number): void {
    if (oroginId) {
      const optionsArray = <FormArray>this.circularRequestForm.controls['TabTwo'].get('Options');
      optionsArray.controls[optionsArray.length - 1].get('CircularsPercentagesId').setValue('');
      if (this.formMode == FormMode.New || this.formMode == FormMode.Edit) {
        this.selectedPercenatge = this.FromRegions.filter((obj) => {
          return obj.CircularsRegions.ID == oroginId;
        });
      }
      else if ( this.formMode == FormMode.Details) {
        this.selectedPercenatge = this.FromRegions.filter((obj) => {
          return obj.Id == oroginId;
        });
      }
      this.originDescription = this.selectedPercenatge[0].CircularsRegions.Description;
      this.OriginshowDescription = true;
      this.DistshowDescription = false;
      this.loadRegionsByOroginIdandCircularID(this.selectedPercenatge[0].CircularsRegions.ID, this.circularRequestForm.controls['TabTwo'].get('CircularsLookupId').value, this.SailingDateFormatted, this.ETAFormatted)
    }
    else {
      this.OriginshowDescription = false;
      this.ToRegions = [];
      this.DistshowDescription = false;
      const optionsArray = <FormArray>this.circularRequestForm.controls['TabTwo'].get('Options');
      optionsArray.controls[optionsArray.length - 1].get('CircularsPercentagesId').setValue('');
    }

  }
  loadPortsCompleted(): void {

    this.ports.sort((a, b) => (a.NameEN > b.NameEN) ? 1 : -1);
    this.lastPortsOrigin = this.firstPortsDestination = this.ports.filter(item => item.CountryId == this.countries[0].Id);
    this.checkLoadedLookups();
  }
  onLastCountrySelect(countryId: number): void {
    const optionsArray = <FormArray>this.circularRequestForm.controls['TabTwo'].get('Options');
    optionsArray.controls[this.rebateRequestOptionsArrLength - 1].get('LastPortOriginId').setValue('');
    optionsArray.controls[this.rebateRequestOptionsArrLength - 1].get('OtherLastPortOrigin').setValue('');
    this.lastPortsOrigin = this.ports.filter(item => item.CountryId == countryId);
  }
  onLastPortSelect(portId: number): void {
    const optionsArray = <FormArray>this.circularRequestForm.controls['TabTwo'].get('Options');
    if (portId == -1) {
      optionsArray.controls[this.rebateRequestOptionsArrLength - 1].patchValue({
        OtherLastPortOrigin: ''
      });
    } else {
      optionsArray.controls[this.rebateRequestOptionsArrLength - 1].patchValue({
        OtherLastPortOrigin: ''
      });
    }
  }
  onFirstCountrySelect(countryId: number): void {
    const optionsArray = <FormArray>this.circularRequestForm.controls['TabTwo'].get('Options');
    optionsArray.controls[this.rebateRequestOptionsArrLength - 1].get('FirstPortDestinationId').setValue('');
    optionsArray.controls[this.rebateRequestOptionsArrLength - 1].get('OtherFirstPortDestination').setValue('');
    this.firstPortsDestination = this.ports.filter(item => item.CountryId == countryId);
  }
  onFirstPortSelect(portId: number): void {
    const optionsArray = <FormArray>this.circularRequestForm.controls['TabTwo'].get('Options');
    if (portId == -1) {
      optionsArray.controls[this.rebateRequestOptionsArrLength - 1].patchValue({
        OtherFirstPortDestination: ''
      });
    } else {
      optionsArray.controls[this.rebateRequestOptionsArrLength - 1].patchValue({
        OtherFirstPortDestination: ''
      });
    }
  }
  loadSailDirections(): void {
    this.lookupService.getSailDirections().subscribe(
      data => this.sailDirections = data.Data as SailDirection[],
      () => console.log("Something went wrong!!"),
      () => this.loadSailDirectionsCompleted()
    );
  }
  loadSailDirectionsCompleted(): void {
    this.sailDirections.sort((a, b) => (a.Direction > b.Direction) ? 1 : -1);
    this.checkLoadedLookups();
  }

  checkLoadedLookups(): void {
    this.noOfLoadedLookups++;
    if (this.noOfLoadedLookups == this.noOfLoadingLookups) {
      this.setFormMode();
    }
  }
  onCargoChange(value: String): void {
    let dw = this.circularRequestForm.controls['TabOne'].get('DWT').value;

    if (Number(value) > Number(dw)) {
      this.showCargoWarning = true;
    }
    else {
      this.showCargoWarning = false;
    }
  }

  buildForm(): void {
    this.circularRequestForm = this.formBuilder.group({
      TabOne: this.formBuilder.group({
        Email: [''],
        OperatorName: ['', [Validators.pattern("[^=]+"), Validators.maxLength(200)]],
        OperatorEmail: ['', [Validators.pattern('^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9_\\-\\.]+)\\.([a-zA-Z]{2,9})$'), Validators.maxLength(50)]],
        VesselName: ['', [Validators.required, Validators.pattern("[^=]+"), Validators.maxLength(200)]],
        VesselTypeId: ['', [Validators.required]],
        YearBuilt: ['', [Validators.required]],
        ExNames: [''],
        BunkeringPort: [''],
        IsScrubberFitted: [''],
        EngineType: [''],
        MainEngineFuelId: [''],
        OtherMainEngineFuel: ['', [Validators.required]],
        CallSign: ['', [Validators.required, Validators.pattern("^[a-zA-Z0-9]*$"), Validators.maxLength(200)]],
        IMONo: ['', [Validators.required, Validators.pattern("^[0-9]{7,9}$")]],
        DWT: ['', [Validators.required, Validators.pattern("^[0-9]{1,6}$"), Validators.maxLength(50)]],
        SCNT: ['', [Validators.required, Validators.pattern("^[1-9][0-9]{0,5}([.][0-9]{1,2}|)$"), Validators.maxLength(50)]],
        SCID: ['', [Validators.pattern("^[0-9]{0,9}$"), Validators.maxLength(50)]],
        LastTransitDate: [''],
        IsShipLoaded: ['', [Validators.required]],
        CargoKind: ['', [Validators.required, Validators.pattern("[^=]+"), Validators.maxLength(200)]],
        CargoQuantity: ['', [Validators.required, Validators.pattern("^[0-9]{1,6}$"), Validators.maxLength(200)]],
        Note: [''],
      }),
      TabTwo: this.formBuilder.group({
        Options: this.formBuilder.array([this.buildLongHaulOptionsForm()]),
        SailDirectionId: ['', [Validators.required]],
        OriginRegionId: ['', [Validators.required]],
        DateOfSailing: ['', [Validators.required, this.SailingdateValidator()]],
        ETD:  ['', [Validators.required, CustomValidators.dateValidator()]],
        ETASC: ['', [Validators.required, CustomValidators.dateValidator()]],
        CircularsLookupId: ['', [Validators.required]],
        Name: ['', [Validators.required, Validators.pattern("[^=]+"), Validators.maxLength(200)]],
        EMail: ['', [Validators.required, Validators.pattern('^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9_\\-\\.]+)\\.([a-zA-Z]{2,9})$'), Validators.maxLength(50)]],
        Fax: ['', [Validators.pattern("^(\\+?\\d{1,}(\\s?|\\-?)\\d*(\\s?|\\-?)\\(?\\d{2,}\\)?(\\s?|\\-?)\\d{3,}\\s?\\d{3,})$")]],
        TermsConditions: ['false', [Validators.pattern('true')]]
      })
    });
  }

  buildLongHaulOptionsForm(): FormGroup {
    return this.formBuilder.group({
      ActualSpeed: ['', [Validators.pattern("^[1-9][0-9]{0,1}([.][0-9]{1,2}|)$"), Validators.maxLength(50)]],
      LastCountryOriginId: ['', [Validators.required]],
      LastPortOriginId: ['', [Validators.required]],
      OtherLastPortOrigin: ['', [Validators.required]],
      CircularsPercentagesId: ['', [Validators.required]],
      FirstCountryDestinationId: ['',],
      FirstPortDestinationId: ['',],
      OtherFirstPortDestination: ['', [Validators.required]],
      IFOTon: ['', [Validators.pattern("^[1-9][0-9]{0,1}([.][0-9]{1,2}|)$"), Validators.maxLength(50)]],
      IFOTonPrice: ['', [Validators.pattern("^[1-9][0-9]{0,3}([.][0-9]{1,2}|)$"), Validators.maxLength(200)]],
      DOTon: ['', [Validators.pattern("^[1-9][0-9]{0,1}([.][0-9]{1,2}|)$"), Validators.maxLength(50)]],
      DOTonPrice: ['', [Validators.pattern("^[1-9][0-9]{0,3}([.][0-9]{1,2}|)$"), Validators.maxLength(200)]],

      Id: [''],
      IsOptionDeleted: [false]
    });
  }
  onOpenYearBuiltCalendar(container) {
    container.yearSelectHandler = (event: any): void => {
      container._store.dispatch(container._actions.select(event.date));
    };
    container.setViewMode('year');
  }

  selectTab(targetTabNumber: number): void {

    if (targetTabNumber == 2) {
      this.isTabOneSubmitted = true;
      const invalidControls = this.tabOneControls.nativeElement.querySelectorAll('.ng-invalid');
      if (this.circularRequestForm.controls['TabOne'].valid || invalidControls.length == 0) {
        this.isTabOneValid = true;
        this.rebateRequestTabs.tabs[targetTabNumber - 1].disabled = false;
        this.rebateRequestTabs.tabs[targetTabNumber - 1].active = true;
        this.cd.detectChanges();
        const el = document.getElementsByClassName('sectionTitle');
        el[0].scrollIntoView({ behavior: 'smooth' });
      } else {
        invalidControls[0].focus();
      }
    } else {
      this.rebateRequestTabs.tabs[targetTabNumber - 1].active = true;
      this.cd.detectChanges();
    }
  }

  addNewVoyage(): void {
    this.isOptionSubmitted = true;
    const invalidControls = this.optionsControls.nativeElement.querySelectorAll('.ng-invalid');
    if (invalidControls.length == 0) {

      this.isOptionsArrValid = true;
      (<FormArray>this.circularRequestForm.controls['TabTwo'].get('Options')).push(this.buildLongHaulOptionsForm());
      this.mapRegionsKeys(this.rebateRequestOptionsArrLength - 1, this.selectedPercenatge[0].FromRegionId, this.circularRequestForm.controls['TabTwo'].value['Options'][this.rebateRequestOptionsArrLength - 1].CircularsPercentagesId, this.circularRequestForm.controls['TabTwo'].value['Options'][this.rebateRequestOptionsArrLength - 1].LastPortOriginId, this.circularRequestForm.controls['TabTwo'].value['Options'][this.rebateRequestOptionsArrLength - 1].FirstPortDestinationId, this.circularRequestForm.controls['TabTwo'].value['Options'][this.rebateRequestOptionsArrLength - 1].OtherLastPortOrigin, this.circularRequestForm.controls['TabTwo'].value['Options'][this.rebateRequestOptionsArrLength - 1].OtherFirstPortDestination);
      this.rebateRequestOptionsArrLength++;
      this.isOptionSubmitted = false;
      const el = document.getElementsByClassName('sectionTitle');
      el[0].scrollIntoView({ behavior: 'smooth' });
      if (this.isETASCGTETAD || this.isDateOfSailingGTETA) {
        this.showSubmit = false;
      }
      else {
        this.showSubmit = true;
      }
      this.isOptionsHeadersEnabled = true;
      this.cannoteditOrigin = true;
      this.circularRequestForm.controls['TabTwo'].get('OriginRegionId').disable();
      this.circularRequestForm.controls['TabTwo'].get('CircularsLookupId').disable();
      this.circularRequestForm.controls['TabTwo'].get('SailDirectionId').disable();
      this.circularRequestForm.controls['TabTwo'].get('DateOfSailing').disable();
      this.circularRequestForm.controls['TabTwo'].get('ETASC').disable();
      this.circularRequestForm.controls['TabTwo'].get('ETD').disable();
      this.DistshowDescription = false;
    } else if (invalidControls.length > 0) {
      invalidControls[0].focus();
      /*if (this.circularRequestForm.controls['TabTwo'].get('DateOfSailing').value > this.circularRequestForm.controls['TabTwo'].get('ETASC').value) {
        const el = document.getElementById('dpDateOfSailing');
        el.scrollIntoView({ behavior: 'smooth' });
        this.isDateOfSailingGTETA = true;
      }
      if (this.circularRequestForm.controls['TabTwo'].get('ETASC').value > this.circularRequestForm.controls['TabTwo'].get('ETD').value) {
        const el = document.getElementById('ETASC');
        el.scrollIntoView({ behavior: 'smooth' });
        this.isETASCGTETAD = true;
      }*/
    }


  }
  dateOfSailingChange(): void {

    if (this.circularRequestForm.controls['TabTwo'].get('DateOfSailing').value != "" && this.circularRequestForm.controls['TabTwo'].get('DateOfSailing').value != null && this.circularRequestForm.controls['TabTwo'].get('ETASC').value != "" && this.circularRequestForm.controls['TabTwo'].get('ETASC').value != null) {

      (this.circularRequestForm.controls['TabTwo'].get('DateOfSailing').value as Date).setHours(0, 0, 0, 0);
      (this.circularRequestForm.controls['TabTwo'].get('ETASC').value as Date).setHours(0, 0, 0, 0);
      if (this.circularRequestForm.controls['TabTwo'].get('DateOfSailing').value <= this.circularRequestForm.controls['TabTwo'].get('ETASC').value)
        this.isDateOfSailingGTETA = false;
      else if (this.circularRequestForm.controls['TabTwo'].get('DateOfSailing').value > this.circularRequestForm.controls['TabTwo'].get('ETASC').value)
        this.isDateOfSailingGTETA = true;
      this.SailingDateFormatted = this.circularRequestForm.controls['TabTwo'].get('DateOfSailing').value.toString().indexOf("-") > -1 ? this.datepipe.transform(new Date(this.circularRequestForm.controls['TabTwo'].get('DateOfSailing').value.split('-')[1] + '/' +
        this.circularRequestForm.controls['TabTwo'].get('DateOfSailing').value.split('-')[0] + '/' + this.circularRequestForm.controls['TabTwo'].get('DateOfSailing').value.split('-')[2]), 'MM/dd/yyyy') :
        this.datepipe.transform(this.circularRequestForm.controls['TabTwo'].get('DateOfSailing').value, 'MM/dd/yyyy');
      this.ETAFormatted = this.circularRequestForm.controls['TabTwo'].get('ETASC').value.toString().indexOf("-") > -1 ? this.datepipe.transform(new Date(this.circularRequestForm.controls['TabTwo'].get('ETASC').value.split('-')[1] + '/' +
        this.circularRequestForm.controls['TabTwo'].get('ETASC').value.split('-')[0] + '/' + this.circularRequestForm.controls['TabTwo'].get('ETASC').value.split('-')[2]), 'MM/dd/yyyy') :
        this.datepipe.transform(this.circularRequestForm.controls['TabTwo'].get('ETASC').value, 'MM/dd/yyyy');

      if(!this.currentUser.IsAdmin){
      if (this.selectedIds) {
        this.circulars = [];
        //this.FromRegions = [];
       // this.circularRequestForm.controls['TabTwo'].get('OriginRegionId').disable();
        this.circularRequestForm.controls['TabTwo'].get('CircularsLookupId').setValue("");
        this.OriginshowDescription = false;
        this.cannoteditOrigin = false;
        this.NoData = false;
        this.loadValidCirculars(this.selectedIds, this.SailingDateFormatted, this.ETAFormatted)
      }
    }
      //this.loadValidCirculars(this.selectedIds)

    } else {
      this.isDateOfSailingGTETA = false;
    }

    if (this.circularRequestForm.controls['TabTwo'].get('ETASC').value != "" && this.circularRequestForm.controls['TabTwo'].get('ETASC').value != null && this.circularRequestForm.controls['TabTwo'].get('ETD').value != "" && this.circularRequestForm.controls['TabTwo'].get('ETD').value != null) {
      (this.circularRequestForm.controls['TabTwo'].get('ETASC').value as Date).setHours(0, 0, 0, 0);
      (this.circularRequestForm.controls['TabTwo'].get('ETD').value as Date).setHours(0, 0, 0, 0);
      if (this.circularRequestForm.controls['TabTwo'].get('ETASC').value <= this.circularRequestForm.controls['TabTwo'].get('ETD').value)
        this.isETASCGTETAD = false;
      else if (this.circularRequestForm.controls['TabTwo'].get('ETASC').value > this.circularRequestForm.controls['TabTwo'].get('ETD').value)
        this.isETASCGTETAD = true;
    } else {
      this.isETASCGTETAD = false;
    }

    if (this.isETASCGTETAD || this.isDateOfSailingGTETA) {
      this.showSubmit = false;
    }
    else {
      this.showSubmit = true;
    }

  }

  editOption(optionIndex): void {
    this.DistDuplicate = false;
    this.showSubmit = false;
    this.isOptionEdited = true;
    this.editedOptionIndex = optionIndex;
    this.emptyCurrentOptionControls();
    const optionsArray = <FormArray>this.circularRequestForm.controls['TabTwo'].get('Options');
    let noOfOptionsToBeDeleted: number = 0
    for (let i: number = 0; i < (optionsArray.value).length; i++) {
      let option = (optionsArray).controls[i];

     //this.selectedOption
      if (option.value["IsOptionDeleted"])
        noOfOptionsToBeDeleted++;
    }

    if ((this.rebateRequestOptionsArrLength - noOfOptionsToBeDeleted) == 2) {

      this.cannoteditOrigin = false;
      this.circularRequestForm.controls['TabTwo'].get('OriginRegionId').enable();
      this.circularRequestForm.controls['TabTwo'].get('CircularsLookupId').enable();
      this.circularRequestForm.controls['TabTwo'].get('SailDirectionId').enable();
      this.circularRequestForm.controls['TabTwo'].get('DateOfSailing').enable();
      this.circularRequestForm.controls['TabTwo'].get('ETASC').enable();
      this.circularRequestForm.controls['TabTwo'].get('ETD').enable();
    }
    this.copyOptionToOption(optionsArray, optionIndex, optionsArray.length - 1);
    if (this.formMode == FormMode.Edit) {
      this.showOptionDev = true;
      this.cd.detectChanges();
    }
  }
  saveEditedVoyage(): void {
    this.isOptionSubmitted = true;
    const invalidControls = this.optionsControls.nativeElement.querySelectorAll('.ng-invalid');
    if (invalidControls.length == 0) {
      //Not Logical Case => FormArray is Ordered DESC
      const optionsArray = <FormArray>this.circularRequestForm.controls['TabTwo'].get('Options');

      this.copyOptionToOption(optionsArray, optionsArray.length - 1, this.editedOptionIndex);
      this.editRegionskeys(this.editedOptionIndex, this.circularRequestForm.controls['TabTwo'].get('OriginRegionId').value, this.circularRequestForm.controls['TabTwo'].value['Options'][this.editedOptionIndex].CircularsPercentagesId, this.circularRequestForm.controls['TabTwo'].value['Options'][this.editedOptionIndex].LastPortOriginId, this.circularRequestForm.controls['TabTwo'].value['Options'][this.editedOptionIndex].FirstPortDestinationId, this.circularRequestForm.controls['TabTwo'].value['Options'][this.editedOptionIndex].OtherLastPortOrigin, this.circularRequestForm.controls['TabTwo'].value['Options'][this.editedOptionIndex].OtherFirstPortDestination);
      this.cannoteditOrigin = true;
      this.circularRequestForm.controls['TabTwo'].get('OriginRegionId').disable();
      this.circularRequestForm.controls['TabTwo'].get('SailDirectionId').disable();
      this.circularRequestForm.controls['TabTwo'].get('CircularsLookupId').disable();
      this.circularRequestForm.controls['TabTwo'].get('DateOfSailing').disable();
      this.circularRequestForm.controls['TabTwo'].get('ETASC').disable();
      this.circularRequestForm.controls['TabTwo'].get('ETD').disable();

      this.editedOptionIndex = -1;
      this.isOptionEdited = false;
      this.emptyCurrentOptionControls();
      this.isOptionSubmitted = false;
      if (this.isETASCGTETAD || this.isDateOfSailingGTETA) {
        this.showSubmit = false;
      }
      else {
        this.showSubmit = true;
      }
      const el = document.getElementsByClassName('sectionTitle');
      el[0].scrollIntoView({ behavior: 'smooth' });
    } else if (invalidControls.length > 0) {
      invalidControls[0].focus();
    }
  }
  emptyCurrentOptionControls(): void {
    const optionsArray = <FormArray>this.circularRequestForm.controls['TabTwo'].get('Options');
    optionsArray.controls[optionsArray.length - 1].get('ActualSpeed').setValue('');
    optionsArray.controls[optionsArray.length - 1].get('LastCountryOriginId').setValue('');
    optionsArray.controls[optionsArray.length - 1].get('LastPortOriginId').setValue('');
    optionsArray.controls[optionsArray.length - 1].get('OtherLastPortOrigin').setValue('');
    optionsArray.controls[optionsArray.length - 1].get('FirstCountryDestinationId').setValue('');
    optionsArray.controls[optionsArray.length - 1].get('FirstPortDestinationId').setValue('');
    optionsArray.controls[optionsArray.length - 1].get('OtherFirstPortDestination').setValue('');
    optionsArray.controls[optionsArray.length - 1].get('IFOTon').setValue('');
    optionsArray.controls[optionsArray.length - 1].get('IFOTonPrice').setValue('');
    optionsArray.controls[optionsArray.length - 1].get('DOTon').setValue('');
    optionsArray.controls[optionsArray.length - 1].get('DOTonPrice').setValue('');
    //optionsArray.controls[optionsArray.length - 1].get('DateOfSailing').setValue('');
    //optionsArray.controls[optionsArray.length - 1].get('ETASC').setValue('');
    //optionsArray.controls[optionsArray.length - 1].get('ETD').setValue('');
    optionsArray.controls[optionsArray.length - 1].get('CircularsPercentagesId').setValue('');
    this.DistshowDescription = false;
    this.DistshowDescription = false;
    this.selectedOption = 0;

  }
  copyOptionToOption(optionsArray, fromIndex, toIndex): void {
    this.lastPortsOrigin = this.ports.filter((item) => item.CountryId == optionsArray.controls[fromIndex].value.LastCountryOriginId);
    this.firstPortsDestination = this.ports.filter((item) => item.CountryId == optionsArray.controls[fromIndex].value.FirstCountryDestinationId);
    optionsArray.controls[toIndex].get('ActualSpeed').setValue(optionsArray.controls[fromIndex].value.ActualSpeed);
    optionsArray.controls[toIndex].get('LastCountryOriginId').setValue(optionsArray.controls[fromIndex].value.LastCountryOriginId);
    optionsArray.controls[toIndex].get('LastPortOriginId').setValue(optionsArray.controls[fromIndex].value.LastPortOriginId);
    optionsArray.controls[toIndex].get('OtherLastPortOrigin').setValue(optionsArray.controls[fromIndex].value.OtherLastPortOrigin);
    optionsArray.controls[toIndex].get('FirstCountryDestinationId').setValue(optionsArray.controls[fromIndex].value.FirstCountryDestinationId);
    optionsArray.controls[toIndex].get('FirstPortDestinationId').setValue(optionsArray.controls[fromIndex].value.FirstPortDestinationId);
    optionsArray.controls[toIndex].get('OtherFirstPortDestination').setValue(optionsArray.controls[fromIndex].value.OtherFirstPortDestination);
    optionsArray.controls[toIndex].get('IFOTon').setValue(optionsArray.controls[fromIndex].value.IFOTon);
    optionsArray.controls[toIndex].get('IFOTonPrice').setValue(optionsArray.controls[fromIndex].value.IFOTonPrice);
    optionsArray.controls[toIndex].get('CircularsPercentagesId').setValue(optionsArray.controls[fromIndex].value.CircularsPercentagesId);
    optionsArray.controls[toIndex].get('DOTon').setValue(optionsArray.controls[fromIndex].value.DOTon);
    optionsArray.controls[toIndex].get('DOTonPrice').setValue(optionsArray.controls[fromIndex].value.DOTonPrice);

    this.selectedOption = optionsArray.controls[fromIndex].value.CircularsPercentagesId;
    //optionsArray.controls[toIndex].get('DateOfSailing').setValue(optionsArray.controls[fromIndex].value.DateOfSailing);
    //optionsArray.controls[toIndex].get('ETASC').setValue(optionsArray.controls[fromIndex].value.ETASC);
    //optionsArray.controls[toIndex].get('ETD').setValue(optionsArray.controls[fromIndex].value.ETD);
    optionsArray.controls[toIndex].get('CircularsPercentagesId').setValue(optionsArray.controls[fromIndex].value.CircularsPercentagesId);
    this.circularRequestForm.controls['TabTwo'].get('Options').updateValueAndValidity();
  }
  cancelEditVoyage(): void {
    this.showSubmit = true;
    this.DistDuplicate = false;
    this.emptyCurrentOptionControls();
    this.editedOptionIndex = -1;
    this.isOptionEdited = false;
    this.OriginshowDescription = false;

    this.circularRequestForm.controls['TabTwo'].get('OriginRegionId').setValue(this.OriginsArr[0].Value);

    if (this.rebateRequestOptionsArrLength >= 1) {
      this.isOptionsHeadersEnabled = true;
      this.cannoteditOrigin = true;
      this.circularRequestForm.controls['TabTwo'].get('OriginRegionId').disable();
      this.circularRequestForm.controls['TabTwo'].get('CircularsLookupId').disable();
      this.circularRequestForm.controls['TabTwo'].get('SailDirectionId').disable();
      this.circularRequestForm.controls['TabTwo'].get('DateOfSailing').disable();
      this.circularRequestForm.controls['TabTwo'].get('ETASC').disable();
      this.circularRequestForm.controls['TabTwo'].get('ETD').disable();
    }
    const el = document.getElementsByClassName('sectionTitle');
    el[0].scrollIntoView({ behavior: 'smooth' });
    this.circularRequestForm.controls['TabTwo'].get('Options').updateValueAndValidity();
  }
  deleteOption(optionIndex): void {
    const optionsArray = <FormArray>this.circularRequestForm.controls['TabTwo'].get('Options');
    optionsArray.controls[optionIndex].patchValue({
      IsOptionDeleted: true
    });
    //Remove Headers if One Option Exists
    let noOfOptionsToBeDeleted: number = 0
    for (let i: number = 0; i < (<FormArray>this.circularRequestForm.controls['TabTwo'].get('Options').value).length; i++) {
      let option = (<FormArray>this.circularRequestForm.controls['TabTwo'].get('Options')).controls[i];
      if (option.value["IsOptionDeleted"])
        noOfOptionsToBeDeleted++;
    }
    if ((this.rebateRequestOptionsArrLength - noOfOptionsToBeDeleted - 1) === 0) {
      this.showSubmit = false;
    }
    else {
      this.showSubmit = true;
    }
    if ((this.rebateRequestOptionsArrLength - noOfOptionsToBeDeleted) == 1) {
      this.isOptionsHeadersEnabled = false;
      this.cannoteditOrigin = false;
      this.circularRequestForm.controls['TabTwo'].get('OriginRegionId').enable();
      this.circularRequestForm.controls['TabTwo'].get('CircularsLookupId').enable();
      this.circularRequestForm.controls['TabTwo'].get('SailDirectionId').enable();
      this.circularRequestForm.controls['TabTwo'].get('DateOfSailing').enable();
      this.circularRequestForm.controls['TabTwo'].get('ETASC').enable();
      this.circularRequestForm.controls['TabTwo'].get('ETD').enable();

    }
    this.noOfOptionsToBeDeletedGlobal = noOfOptionsToBeDeleted;
    //this.rebateRequestOptionsArrLength--;
  }
  detailsOption(optionIndex): void {
    this.showOptionDev = true;
    this.emptyCurrentOptionControls();

    const optionsArray = <FormArray>this.circularRequestForm.controls['TabTwo'].get('Options');
    this.copyOptionToOption(optionsArray, optionIndex, optionsArray.length - 1);
    if (this.formMode == FormMode.Edit || this.formMode == FormMode.Details)
      this.cd.detectChanges();
    //this.isOptionDisplayedDetailsMode = true;
  }
  cancelRequest(): void {
    // localStorage.setItem('requestId', this.rebateRequestId);
    this.route.navigate(['CircularRequest/Cancel'], { state: { data: { requestId: this.rebateRequestId } } });
  }
  //Submit
  submit(): void {

    if (this.formMode == FormMode.Edit)
      this.isTabOneSubmitted = true;
    this.isFormSubmitted = true;
    this.isTabTwoSubmitted = true;
    //Check Form Validity
    //Options Validity - Edit Mode
    if (this.circularRequestForm.controls['TabTwo'].get('Options').value.length != 1 && this.formMode == FormMode.Edit) {
      this.isOptionsArrValid = true;
    }
    //Count Number of Deleted Options
    for (let i: number = 0; i < (<FormArray>this.circularRequestForm.controls['TabTwo'].get('Options').value).length; i++) {
      let option = (<FormArray>this.circularRequestForm.controls['TabTwo'].get('Options')).controls[i];
      if (option.value["IsOptionDeleted"])
        this.noOfDeletedOptions++;
    }
    //Tab One Validity
    const tabOneInValidControls = this.tabOneControls.nativeElement.querySelectorAll('.ng-invalid');
    const tabTwoInValidControls = this.tabTwoControls.nativeElement.querySelectorAll('.ng-invalid');
    const tabTwoPrincipalInValidControls = this.tabTwoPrincipalControls.nativeElement.querySelectorAll('.ng-invalid');
    if (!this.circularRequestForm.controls['TabOne'].valid && tabOneInValidControls.length > 0) {
      this.rebateRequestTabs.tabs[0].active = true;
      this.cd.detectChanges();
      if (tabOneInValidControls.length > 0)
        tabOneInValidControls[0].focus();
      //Options Validation
    } else if ((this.circularRequestForm.controls['TabTwo'].get('Options').value.length - this.noOfDeletedOptions) == 1) {
      //Default Array Contain at Least One Object
      this.rebateRequestTabs.tabs[1].active = true;
      this.cd.detectChanges();
      this.isOptionsArrValid = false;
      const invalidControls = this.optionsControls.nativeElement.querySelectorAll('.ng-invalid');
      if (invalidControls.length > 0) {
        invalidControls[0].focus();
      } else {
        const el = document.getElementsByClassName('sectionTitle');
        el[0].scrollIntoView({ behavior: 'smooth' });
      }
      if (this.isOptionsValidatedFromSubmit)
        this.isOptionSubmitted = true;
      this.isOptionsValidatedFromSubmit = true;
      //Tab Two Validity
    } else if (!this.circularRequestForm.controls['TabTwo'].valid && tabTwoInValidControls.length > 0) {
      this.isTabTwoValid = false;
      this.rebateRequestTabs.tabs[1].active = true;
      this.cd.detectChanges();
      if (tabTwoInValidControls.length > 0) {
        tabTwoInValidControls[0].focus();

      }

    } else if (!this.circularRequestForm.controls['TabTwo'].valid && tabTwoPrincipalInValidControls.length > 0) {
      this.isTabTwoValid = false;
      this.rebateRequestTabs.tabs[1].active = true;
      this.cd.detectChanges();
      if (tabTwoInValidControls.length > 0)
        tabTwoInValidControls[0].focus();
      //Form Valid
    } else {
      this.circularRequestObject = { ...this.circularRequestForm.controls['TabOne'].value, ...this.circularRequestForm.controls['TabTwo'].value };
      this.circularRequestObject.SailDirectionId = this.circularRequestForm.controls['TabTwo'].get('SailDirectionId').value;
      this.circularRequestObject.CircularsLookupId = this.circularRequestForm.controls['TabTwo'].get('CircularsLookupId').value;
      this.circularRequestObject.OriginRegionId = this.circularRequestForm.controls['TabTwo'].get('OriginRegionId').value;
      this.circularRequestObject.DateOfSailing = this.circularRequestForm.controls['TabTwo'].get('DateOfSailing').value;
      this.circularRequestObject.ETASC = this.circularRequestForm.controls['TabTwo'].get('ETASC').value;
      this.circularRequestObject.ETD = this.circularRequestForm.controls['TabTwo'].get('ETD').value;
      if (this.circularRequestObject.OriginRegionId == '' || this.circularRequestObject.SailDirectionId == '' || this.circularRequestObject.CircularsLookupId == '') {
        this.isTabTwoValid = false;
        this.rebateRequestTabs.tabs[1].active = true;
        window.scrollTo(50, 500);
      }
      else {
        this.circularRequestObject.Options.pop();

        let directionId = this.circularRequestObject.SailDirectionId;
        let CircularsLookupId = this.circularRequestObject.CircularsLookupId;

        let OriginRegionId = this.circularRequestObject.OriginRegionId;
        delete this.circularRequestObject.SailDirectionId;
        for (let i: number = 0; i < this.circularRequestObject.Options.length; i++) {
          if (directionId != undefined)
            this.circularRequestObject.Options[i]["SailDirectionId"] = directionId;
          else
            this.circularRequestObject.Options[i]["SailDirectionId"] = this.clonedComponentDirectionId;
          /*if (CircularsLookupId != undefined)
            this.circularRequestObject.Options[i]["CircularsLookupId"] = CircularsLookupId;
          else
            this.circularRequestObject.Options[i]["CircularsLookupId"] = this.clonedComponentCircularId;*/

          if (OriginRegionId != undefined)
            this.circularRequestObject.Options[i]["OriginRegionId"] = OriginRegionId;
          else
            this.circularRequestObject.Options[i]["OriginRegionId"] = this.clonedComponentCircularId;


        }
        //Enable Loader
        this.globalServices.isLoaderEnabled = true;
        //Submit Request
        this.circularRequestObject.CircularsFixedRebateOptions = this.circularRequestObject.Options;
        delete this.circularRequestObject.Options;
        delete this.circularRequestObject.Email;
        for (let i: number = 0; i < this.circularRequestObject.CircularsFixedRebateOptions.length; i++) {

          this.circularRequestObject.CircularsFixedRebateOptions[i].FromRegionId = this.selectedPercenatge[0].CircularsRegions.ID;
          if (this.circularRequestObject.CircularsFixedRebateOptions[i].LastPortOriginId == -1)
            this.circularRequestObject.CircularsFixedRebateOptions[i].LastPortOriginId = null;
          if (this.circularRequestObject.CircularsFixedRebateOptions[i].FirstPortDestinationId == -1)
            this.circularRequestObject.CircularsFixedRebateOptions[i].FirstPortDestinationId = null;

          if (this.circularRequestObject.CircularsFixedRebateOptions[i].LastCountryOriginId == -1)
            this.circularRequestObject.CircularsFixedRebateOptions[i].LastCountryOriginId = null;
          if (this.circularRequestObject.CircularsFixedRebateOptions[i].FirstCountryDestinationId == -1)
            this.circularRequestObject.CircularsFixedRebateOptions[i].FirstCountryDestinationId = null;

          if (this.circularRequestObject.CircularsFixedRebateOptions[i].LastPortOriginId == "")
            this.circularRequestObject.CircularsFixedRebateOptions[i].LastPortOriginId = null;
          if (this.circularRequestObject.CircularsFixedRebateOptions[i].FirstPortDestinationId == "")
            this.circularRequestObject.CircularsFixedRebateOptions[i].FirstPortDestinationId = null;

          if (this.circularRequestObject.CircularsFixedRebateOptions[i].LastCountryOriginId == "")
            this.circularRequestObject.CircularsFixedRebateOptions[i].LastCountryOriginId = null;
          if (this.circularRequestObject.CircularsFixedRebateOptions[i].FirstCountryDestinationId == "")
            this.circularRequestObject.CircularsFixedRebateOptions[i].FirstCountryDestinationId = null;

        }
        if (this.circularRequestObject.MainEngineFuelId == -1)
          this.circularRequestObject.MainEngineFuelId = null;
        if (this.isCloneComponent) {
          //here
          this.circularRequestObject.IsShipLoaded = this.circularRequestForm.controls['TabOne'].get('IsShipLoaded').value;
          this.circularRequestObject.CargoKind = this.circularRequestForm.controls['TabOne'].get('CargoKind').value;
          this.circularRequestObject.CargoQuantity = this.circularRequestForm.controls['TabOne'].get('CargoQuantity').value;
          this.circularRequestObject.VesselName = this.circularRequestForm.controls['TabOne'].get('VesselName').value;
          this.circularRequestObject.CallSign = this.circularRequestForm.controls['TabOne'].get('CallSign').value;
          this.circularRequestObject.IMONo = this.circularRequestForm.controls['TabOne'].get('IMONo').value;
          this.circularRequestObject.SCNT = this.circularRequestForm.controls['TabOne'].get('SCNT').value;
          this.circularRequestObject.DWT = this.circularRequestForm.controls['TabOne'].get('DWT').value;
          this.circularRequestObject.LastTransitDate = this.circularRequestForm.controls['TabOne'].get('LastTransitDate').value;
          this.circularRequestObject.YearBuilt = this.circularRequestForm.controls['TabOne'].get('YearBuilt').value;
          this.circularRequestObject.VesselTypeId = this.circularRequestForm.controls['TabOne'].get('VesselTypeId').value;
          this.circularRequestObject.RequestorId = this.currentUser.UserId;
          this.circularRequestObject.RequestorEmail = this.currentUser.UserName != "" ? this.currentUser.UserName : this.currentUser.Email;
          this.circularRequestObject.Id = this.rebateRequestLoaded.Id;
          this.circularRequestObject.ServiceId = Service.circulars;
          this.circularRequestObject.StatusId = ServiceStatus.Circulars_NewRequest;
          this.circularRequestObject.IsSubmitClone = true;

          this.submitRebateRequest();
        } else {
          if (this.formMode == FormMode.New) {
            this.circularRequestObject.RebateFileNumber = this.SelectedCircular.Symbol;
            this.circularRequestObject.RequestorId = this.currentUserId;
            this.circularRequestObject.RequestorEmail = this.currentUserEmail;
            this.circularRequestObject.ServiceId = Service.circulars;
            this.circularRequestObject.StatusId = ServiceStatus.Circulars_NewRequest;
            this.circularRequestObject.IsSubmitClone = false;
            this.circularRequestObject.CreatedBy = this.currentUserEmail;
            this.circularRequestObject.CreationDate = this.rebateRequestLoaded.CreationDate;
            this.circularRequestObject.ModifiedBy = this.currentUserEmail;
            this.circularRequestObject.ModifiedDate = this.rebateRequestLoaded.ModifiedDate;
            this.submitRebateRequest();
          } else if (this.formMode == FormMode.Edit) {
            if (this.rebateRequestLoaded.IsSubRequest && this.rebateRequestLoaded.InternalStatusId != 1107) {
              this.circularRequestObject.IsShipLoaded = this.circularRequestForm.controls['TabOne'].get('IsShipLoaded').value;
              this.circularRequestObject.CargoKind = this.circularRequestForm.controls['TabOne'].get('CargoKind').value;
              this.circularRequestObject.CargoQuantity = this.circularRequestForm.controls['TabOne'].get('CargoQuantity').value;
              this.circularRequestObject.VesselName = this.circularRequestForm.controls['TabOne'].get('VesselName').value;
              this.circularRequestObject.CallSign = this.circularRequestForm.controls['TabOne'].get('CallSign').value;
              this.circularRequestObject.IMONo = this.circularRequestForm.controls['TabOne'].get('IMONo').value;
              this.circularRequestObject.SCNT = this.circularRequestForm.controls['TabOne'].get('SCNT').value;
              this.circularRequestObject.DWT = this.circularRequestForm.controls['TabOne'].get('DWT').value;
              this.circularRequestObject.LastTransitDate = this.circularRequestForm.controls['TabOne'].get('LastTransitDate').value;
              this.circularRequestObject.YearBuilt = this.circularRequestForm.controls['TabOne'].get('YearBuilt').value;
              this.circularRequestObject.VesselTypeId = this.circularRequestForm.controls['TabOne'].get('VesselTypeId').value
            }
            this.circularRequestObject.RebateFileNumber = this.rebateRequestLoaded.RebateFileNumber;
            this.circularRequestObject.AdminSCID = this.rebateRequestLoaded.AdminSCID;
            this.circularRequestObject.RefundedPercentageId = this.rebateRequestLoaded.RefundedPercentageId;
            this.circularRequestObject.AdminRejectionReason = this.rebateRequestLoaded.AdminRejectionReason;
            this.circularRequestObject.hasRequestorDecision = this.rebateRequestLoaded.hasRequestorDecision;
            this.circularRequestObject.RequestorDecisionRejectionReason = this.rebateRequestLoaded.RequestorDecisionRejectionReason;
            this.circularRequestObject.RequestorEmail = this.currentUserEmail;
            this.circularRequestObject.Id = this.rebateRequestLoaded.Id;
            this.circularRequestObject.InternalStatusId = this.rebateRequestLoaded.InternalStatusId;
            this.circularRequestObject.ExternalStatusId = this.rebateRequestLoaded.ExternalStatusId;
            this.circularRequestObject.CreatedBy = this.rebateRequestLoaded.CreatedBy;
            this.circularRequestObject.CreationDate = this.rebateRequestLoaded.CreationDate;
            this.circularRequestObject.ModifiedBy = this.rebateRequestLoaded.ModifiedBy;
            this.circularRequestObject.ModifiedDate = this.rebateRequestLoaded.ModifiedDate;
            this.circularRequestObject.IsDeleted = this.rebateRequestLoaded.IsDeleted;
            this.circularRequestObject.IsEditable = this.rebateRequestLoaded.IsEditable;
            this.circularRequestObject.FileNumber = this.rebateRequestLoaded.FileNumber;
            this.circularRequestObject.RebateStatusId = this.rebateRequestLoaded.RebateStatusId;
            this.circularRequestObject.IsShipPassed = this.rebateRequestLoaded.IsShipPassed;
            this.circularRequestObject.CancelationReason = this.rebateRequestLoaded.CancelationReason;
            this.circularRequestObject.CancelationMessage = this.rebateRequestLoaded.CancelationMessage;
            this.isRequireModificationNotesExist = false;
            this.submitEditedRequest();
          }
        }
      }
    }
    this.noOfDeletedOptions = 0;
  }

  submitRebateRequest(): void {

    this.setDateTimeDefault();
    this.circularService.Add(this.circularRequestObject).subscribe(
      data => this.submitRebateRequestResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.submitRebateRequestCompleted()
    );
  }
  submitRebateRequestCompleted(): void {
    if (this.submitRebateRequestResponseObject.Success) {
      //Enable Confirmation
      this.confirmationMessage = "Your Request has been successfully submitted and is being reviewed by Suez Canal Authority Team";
    } else {
      //Enable Error
      this.submitConfirmationMode = ConfirmationMode.Error;
    }
    this.isFormValid = true;
    //Disable Loader
    this.globalServices.isLoaderEnabled = false;
  }
  submitEditedRequest(): void {
    this.setDateTimeDefault();
    this.circularService.submitEditedRequest(this.circularRequestObject).subscribe(
      data => this.submitRebateRequestResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.submitEditedRebateRequestCompleted()
    );
  }
  submitEditedRebateRequestCompleted(): void {
    if (this.submitRebateRequestResponseObject.Success) {
      //Enable Confirmation
      this.confirmationMessage = "Your Request has been successfully edited and is being reviewed by Suez Canal Authority Team";
    } else {
      //Enable Error
      this.submitConfirmationMode = ConfirmationMode.Error;
    }
    this.isFormValid = true;
    //Disable Loader
    this.globalServices.isLoaderEnabled = false;
  }

  getCurrentLoggedUser(): void {
    //Staging Mode
    this.currentUserEmail = this.currentUser.UserName != "" ? this.currentUser.UserName : this.currentUser.Email;
    this.currentUserId = this.currentUser.UserId;

    const el = document.getElementsByClassName('sectionTitle');
    if (el[0] != undefined)
      el[0].scrollIntoView({ behavior: 'smooth' });
    this.globalServices.isLoaderEnabled = false;
  }

  setDefaults(): void {

    this.rebateRequestTabs.tabs[1].disabled = false; // here
    this.cd.detectChanges();
  }

  getRequestTimeBeforeSailingDate(ExpirationdependsOnETA: boolean): void {


    if (ExpirationdependsOnETA) {
      let requestTimeBeforeSailingDateDays = 90;
      this.dateOfSailing.setDate(this.todayDate.getDate() - requestTimeBeforeSailingDateDays);

    }
    else {
      let requestTimeBeforeSailingDateDays = Math.floor(this.requestTimeBeforeSailingDate / 24);
      this.dateOfSailing.setDate(this.dateOfSailing.getDate() + requestTimeBeforeSailingDateDays);
    }
  }
  //Form Mode
  setFormMode(): void {
    //Edit Mode / Display Mode
    if (this.rebateRequestId != '') {
      //Enable Loader
      this.globalServices.isLoaderEnabled = true;
      //Get Long Haul Request by Id
      this.getRequest();
    } else {
      //New Mode
      this.showOptionDev = true;
      //Requester [Current User]
      this.getCurrentLoggedUser();
    }
  }
  getRequest(): void {
    this.circularService.getRequest(this.rebateRequestId).subscribe(
      data => this.getRebateRequestResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.getRebateRequestCompleted()
    );
  }
  loadCircular(value: Number): void {
    let all = this.vesselTypes.filter((obj) => {
      return obj.VesselTypeId == value;
    });

    let selectedIds = all.map(({ CircularsLookupID }) => CircularsLookupID);
    this.selectedIds = selectedIds;

    this.loadFilteredCirculars(selectedIds)
  }
  LaodParentData(parentID): void {
    this.circularService.getRequest(parentID).subscribe(
      data => this.getRebateRequestResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.getParentRebateRequestCompleted()
    );
  }
  getParentRebateRequestCompleted(): void {
    if (this.getRebateRequestResponseObject.Success) {

      this.ParentRequestLoaded = this.getRebateRequestResponseObject.Data as CircularRequest;
      this.ParentCreationDateForSubRequest = this.ParentRequestLoaded.BaseRequest.CreationDate;
    }
  }
  getRebateRequestCompleted(): void {
    if (this.getRebateRequestResponseObject.Success) {
      this.rebateRequestLoaded = this.getRebateRequestResponseObject.Data as CircularRequest;
      if (this.rebateRequestLoaded.ParentRequestNumber) {
        this.LaodParentData(this.rebateRequestLoaded.BaseRequest.ParentRequestId);
      }

      if (
        this.rebateRequestLoaded.BaseRequest.StatusId == ServiceStatus.Circulars_PendingRequestorApproval
        || this.rebateRequestLoaded.BaseRequest.StatusId == ServiceStatus.Circulars_AcceptedByRequestor
        || this.rebateRequestLoaded.BaseRequest.StatusId == ServiceStatus.Circulars_RejectedByRequestor
        || this.rebateRequestLoaded.BaseRequest.StatusId == ServiceStatus.Circulars_TripCancelledByUser
        || this.rebateRequestLoaded.BaseRequest.StatusId == ServiceStatus.Circulars_ClosedRefunded
        || this.rebateRequestLoaded.BaseRequest.StatusId == ServiceStatus.Circulars_ClosedPendingRefund
        || this.rebateRequestLoaded.BaseRequest.StatusId == ServiceStatus.Circulars_ClosedCancelled
        || this.rebateRequestLoaded.BaseRequest.StatusId == ServiceStatus.Circulars_RequestClosed
      ) {
        if (!this.isCloneComponent) { this.showPDF = true; }
      }
      else {
        this.showPDF = false;
      }

      this.rebateRequestLoaded.ActivityInstanceID = this.ActivityInstanceID;

      this.rebateRequestCreationDate = this.rebateRequestLoaded.CreationDate;
      this.loadCircular(this.rebateRequestLoaded.VesselTypeId);
      /*if (this.rebateRequestLoaded.BaseRequest.StatusId == ServiceStatus.Circulars_MoreInformationRequestedFromAgent || this.rebateRequestLoaded.BaseRequest.StatusId == ServiceStatus.Circulars_NewRequest || this.rebateRequestLoaded.BaseRequest.StatusId == ServiceStatus.Circulars_NewRequest_EditedbyUser || this.rebateRequestLoaded.BaseRequest.StatusId == ServiceStatus.Circulars_NewRequest_ModifiedbyRequester) {
        this.LoadFromRegionss(this.rebateRequestLoaded.CircularsLookupId, this.rebateRequestLoaded.CircularsFixedRebateOptions[0].SailDirectionId, this.rebateRequestLoaded.ETASC, this.rebateRequestLoaded.DateOfSailing);
        this.circularRequestForm.controls['TabTwo'].get('OriginRegionId').disable();
        this.circularRequestForm.controls['TabTwo'].get('ETASC').disable();
        this.circularRequestForm.controls['TabTwo'].get('ETD').disable();
        this.circularRequestForm.controls['TabTwo'].get('DateOfSailing').disable();
      }
      else {

        this.loadRegionsByOroginIdinDetails(this.rebateRequestLoaded.CircularsLookupId, this.rebateRequestLoaded.CircularsFixedRebateOptions[0].SailDirectionId);
        this.circularRequestForm.controls['TabTwo'].get('OriginRegionId').disable();

      }*/

      this.loadRegionsByOroginIdinDetails(this.rebateRequestLoaded.CircularsLookupId, this.rebateRequestLoaded.CircularsFixedRebateOptions[0].SailDirectionId);


    }
    else {
      //Enable Error
      this.submitConfirmationMode = ConfirmationMode.Error;
      this.isFormValid = true;
    }

  }
  LoadPercentages(): void {
    this.circularService.getPercentagesByCircularId(this.rebateRequestLoaded.CircularsLookupId.toString()).subscribe(
      data => this.Percentages = data.Data as Percentages[],
      () => console.log("Something went wrong!!"),
    );
  }

  onMainEngineFuelTypeChange(mainEngineFuelTypeId: number): void {
    if (mainEngineFuelTypeId == -1) {
      (this.circularRequestForm.controls['TabOne'] as FormGroup).controls['OtherMainEngineFuel'].setValidators([Validators.required]);
      (this.circularRequestForm.controls['TabOne'] as FormGroup).controls['OtherMainEngineFuel'].updateValueAndValidity();
    } else {
      (this.circularRequestForm.controls['TabOne'] as FormGroup).controls['OtherMainEngineFuel'].reset();
      (this.circularRequestForm.controls['TabOne'] as FormGroup).controls['OtherMainEngineFuel'].clearValidators();
      (this.circularRequestForm.controls['TabOne'] as FormGroup).controls['OtherMainEngineFuel'].updateValueAndValidity();
    }
  }
  fillcircularRequestObject(): void {
    this.getAgentOnly(this.rebateRequestLoaded.BaseRequest.RequestorId);
    this.currentUserEmail = this.rebateRequestLoaded.RequestorEmail;
    let isShipLoaded: string = this.rebateRequestLoaded.IsShipLoaded ? "true" : "false";
    let isScrubberFitted: string = this.rebateRequestLoaded.IsScrubberFitted ? "true" : "false";
    let EngineType: string = this.rebateRequestLoaded.EngineType ? "true" : "false";
    let mainEngineFuelId;
    if (this.rebateRequestLoaded.MainEngineFuelId == null && (this.rebateRequestLoaded.OtherMainEngineFuel == null || this.rebateRequestLoaded.OtherMainEngineFuel == ""))
      mainEngineFuelId = '';
    else if (this.rebateRequestLoaded.MainEngineFuelId == null && this.rebateRequestLoaded.OtherMainEngineFuel != null)
      mainEngineFuelId = -1;
    else
      mainEngineFuelId = this.rebateRequestLoaded.MainEngineFuelId;
    this.circularRequestForm.controls['TabOne'].patchValue({
      OperatorName: this.rebateRequestLoaded.OperatorName,
      OperatorEmail: this.rebateRequestLoaded.OperatorEmail,
      VesselName: this.rebateRequestLoaded.VesselName,
      VesselTypeId: this.rebateRequestLoaded.VesselTypeId,
      ExNames: this.rebateRequestLoaded.ExNames,
      BunkeringPort: this.rebateRequestLoaded.BunkeringPort,
      YearBuilt: this.rebateRequestLoaded.YearBuilt === null ? '' : new Date(this.rebateRequestLoaded.YearBuilt),
      CallSign: this.rebateRequestLoaded.CallSign,
      IMONo: this.rebateRequestLoaded.IMONo,
      DWT: this.rebateRequestLoaded.DWT,
      SCNT: this.rebateRequestLoaded.SCNT,
      SCID: this.rebateRequestLoaded.SCID,
      LastTransitDate: this.rebateRequestLoaded.LastTransitDate != null && this.rebateRequestLoaded.LastTransitDate != "" ? new Date(this.rebateRequestLoaded.LastTransitDate) : null,
      IsScrubberFitted: isScrubberFitted,
      EngineType: EngineType,
      MainEngineFuelId: mainEngineFuelId,
      OtherMainEngineFuel: this.rebateRequestLoaded.OtherMainEngineFuel,

      CargoKind: this.rebateRequestLoaded.CargoKind,
      CargoQuantity: this.rebateRequestLoaded.CargoQuantity,
      //TPITPC: this.rebateRequestLoaded.TPITPC
      IsShipLoaded: isShipLoaded,
      Note: this.rebateRequestLoaded.Note
    });

    if (!this.isCloneComponent) {
      const optionsArray = <FormArray>this.circularRequestForm.controls['TabTwo'].get('Options');
      this.rebateRequestOptionsArrLength = this.rebateRequestLoaded.CircularsFixedRebateOptions.length + 1;
      for (let i: number = 0; i < this.rebateRequestLoaded.CircularsFixedRebateOptions.length; i++) {
        if (i > 0)
          (<FormArray>this.circularRequestForm.controls['TabTwo'].get('Options')).push(this.buildLongHaulOptionsForm());
        /* let LastPortOriginId;
         if (this.rebateRequestLoaded.CircularsFixedRebateOptions[i].LastPortOriginId == null && this.rebateRequestLoaded.CircularsFixedRebateOptions[i].OtherLastPortOrigin == '') {
           LastPortOriginId = ''
         }
         else {
           LastPortOriginId = this.rebateRequestLoaded.CircularsFixedRebateOptions[i].LastPortOriginId;
         }

         let FirstPortDestinationId;
         if (this.rebateRequestLoaded.CircularsFixedRebateOptions[i].FirstPortDestinationId == null && this.rebateRequestLoaded.CircularsFixedRebateOptions[i].OtherFirstPortDestination == '') {
           FirstPortDestinationId = ''
         }
         else {
           FirstPortDestinationId = this.rebateRequestLoaded.CircularsFixedRebateOptions[i].FirstPortDestinationId;
         }*/
        let lastPort;
        let firstPort;
        if (this.rebateRequestLoaded.CircularsFixedRebateOptions[i].LastPortOriginId == null) {
          if (this.rebateRequestLoaded.CircularsFixedRebateOptions[i].OtherLastPortOrigin == "") {
            lastPort = null;
          }
          else {
            lastPort = -1;
          }
        }
        else {
          lastPort = this.rebateRequestLoaded.CircularsFixedRebateOptions[i].LastPortOriginId;
        }

        if (this.rebateRequestLoaded.CircularsFixedRebateOptions[i].FirstPortDestinationId == null) {
          if (this.rebateRequestLoaded.CircularsFixedRebateOptions[i].OtherFirstPortDestination == "") {
            firstPort = null;
          }
          else {
            firstPort = -1;
          }
        }
        else {
          firstPort = this.rebateRequestLoaded.CircularsFixedRebateOptions[i].FirstPortDestinationId;
        }
        optionsArray.controls[i].patchValue({

          ActualSpeed: this.rebateRequestLoaded.CircularsFixedRebateOptions[i].ActualSpeed,
          LastCountryOriginId: this.rebateRequestLoaded.CircularsFixedRebateOptions[i].LastCountryOriginId,
          //LastPortOriginId: this.rebateRequestLoaded.CircularsFixedRebateOptions[i].LastPortOriginId == null ? -1 : this.rebateRequestLoaded.CircularsFixedRebateOptions[i].LastPortOriginId,
          LastPortOriginId: lastPort,
          OtherLastPortOrigin: this.rebateRequestLoaded.CircularsFixedRebateOptions[i].OtherLastPortOrigin,
          FirstCountryDestinationId: this.rebateRequestLoaded.CircularsFixedRebateOptions[i].FirstCountryDestinationId,
          FirstPortDestinationId: firstPort,
          //FirstPortDestinationId: this.rebateRequestLoaded.CircularsFixedRebateOptions[i].FirstPortDestinationId == null ? -1 : this.rebateRequestLoaded.CircularsFixedRebateOptions[i].FirstPortDestinationId,
          OtherFirstPortDestination: this.rebateRequestLoaded.CircularsFixedRebateOptions[i].OtherFirstPortDestination,
          IFOTon: this.rebateRequestLoaded.CircularsFixedRebateOptions[i].IFOTon,
          IFOTonPrice: this.rebateRequestLoaded.CircularsFixedRebateOptions[i].IFOTonPrice,
          CircularsPercentagesId: this.rebateRequestLoaded.CircularsFixedRebateOptions[i].CircularsPercentagesId,
          DOTon: this.rebateRequestLoaded.CircularsFixedRebateOptions[i].DOTon,
          DOTonPrice: this.rebateRequestLoaded.CircularsFixedRebateOptions[i].DOTonPrice,
          // DateOfSailing: new Date(this.rebateRequestLoaded.CircularsFixedRebateOptions[i].DateOfSailing),
          // ETASC: new Date(this.rebateRequestLoaded.CircularsFixedRebateOptions[i].ETASC),
          // ETD: new Date(this.rebateRequestLoaded.CircularsFixedRebateOptions[i].ETD),
          Id: this.rebateRequestLoaded.CircularsFixedRebateOptions[i].Id,
          IsOptionDeleted: false
        });
        this.mapRegionsKeys(i, this.rebateRequestLoaded.CircularsFixedRebateOptions[i].FromRegionId, this.rebateRequestLoaded.CircularsFixedRebateOptions[i].CircularsPercentagesId, this.rebateRequestLoaded.CircularsFixedRebateOptions[i].LastPortOriginId, this.rebateRequestLoaded.CircularsFixedRebateOptions[i].FirstPortDestinationId, this.rebateRequestLoaded.CircularsFixedRebateOptions[i].OtherLastPortOrigin, this.rebateRequestLoaded.CircularsFixedRebateOptions[i].OtherFirstPortDestination)
      }
      (<FormArray>this.circularRequestForm.controls['TabTwo'].get('Options')).push(this.buildLongHaulOptionsForm());

      this.circularRequestForm.controls['TabTwo'].get('SailDirectionId').enable();
      this.circularRequestForm.controls['TabTwo'].get('CircularsLookupId').enable();
      this.circularRequestForm.controls['TabTwo'].get('OriginRegionId').enable();

    } else {
      //disable in clone

      this.circularRequestForm.controls['TabTwo'].get('SailDirectionId').disable();
      this.circularRequestForm.controls['TabTwo'].get('ETD').disable();
      this.circularRequestForm.controls['TabTwo'].get('ETASC').disable();
      this.circularRequestForm.controls['TabTwo'].get('DateOfSailing').disable();
      this.circularRequestForm.controls['TabTwo'].get('CircularsLookupId').disable();
      this.circularRequestForm.controls['TabOne'].get('VesselTypeId').disable();
      this.circularRequestForm.controls['TabOne'].get('OperatorName').disable();
      this.circularRequestForm.controls['TabOne'].get('OperatorEmail').disable();
      this.circularRequestForm.controls['TabOne'].get('VesselName').disable();
      this.circularRequestForm.controls['TabOne'].get('ExNames').disable();
      this.circularRequestForm.controls['TabOne'].get('YearBuilt').disable();
      this.circularRequestForm.controls['TabOne'].get('CallSign').disable();
      this.circularRequestForm.controls['TabOne'].get('IMONo').disable();
      this.circularRequestForm.controls['TabOne'].get('SCID').disable();
      this.circularRequestForm.controls['TabOne'].get('SCNT').disable();
      this.circularRequestForm.controls['TabOne'].get('LastTransitDate').disable();
      this.circularRequestForm.controls['TabOne'].get('BunkeringPort').disable();
      this.circularRequestForm.controls['TabOne'].get('MainEngineFuelId').disable();
      this.circularRequestForm.controls['TabOne'].get('EngineType').disable();
      this.circularRequestForm.controls['TabOne'].get('IsScrubberFitted').disable();
      this.circularRequestForm.controls['TabOne'].get('IsShipLoaded').disable();
      this.circularRequestForm.controls['TabOne'].get('MainEngineFuelId').disable();
      this.circularRequestForm.controls['TabOne'].get('DWT').disable();
      this.circularRequestForm.controls['TabOne'].get('CargoKind').disable();
      this.circularRequestForm.controls['TabOne'].get('CargoQuantity').disable();

    }
    if (this.rebateRequestLoaded.IsSubRequest && this.rebateRequestLoaded.InternalStatusId != 1107) {
      this.circularRequestForm.controls['TabTwo'].get('SailDirectionId').disable();
      this.circularRequestForm.controls['TabTwo'].get('ETD').disable();
      this.circularRequestForm.controls['TabTwo'].get('ETASC').disable();
      this.circularRequestForm.controls['TabTwo'].get('DateOfSailing').disable();
      this.circularRequestForm.controls['TabTwo'].get('CircularsLookupId').disable();
      this.circularRequestForm.controls['TabTwo'].get('OriginRegionId').disable();
      this.circularRequestForm.controls['TabOne'].get('VesselTypeId').disable();
      this.circularRequestForm.controls['TabOne'].get('OperatorName').disable();
      this.circularRequestForm.controls['TabOne'].get('OperatorEmail').disable();
      this.circularRequestForm.controls['TabOne'].get('VesselName').disable();
      this.circularRequestForm.controls['TabOne'].get('ExNames').disable();
      this.circularRequestForm.controls['TabOne'].get('YearBuilt').disable();
      this.circularRequestForm.controls['TabOne'].get('CallSign').disable();
      this.circularRequestForm.controls['TabOne'].get('IMONo').disable();
      this.circularRequestForm.controls['TabOne'].get('SCID').disable();
      this.circularRequestForm.controls['TabOne'].get('SCNT').disable();
      this.circularRequestForm.controls['TabOne'].get('LastTransitDate').disable();
      this.circularRequestForm.controls['TabOne'].get('BunkeringPort').disable();
      this.circularRequestForm.controls['TabOne'].get('MainEngineFuelId').disable();
      this.circularRequestForm.controls['TabOne'].get('EngineType').disable();
      this.circularRequestForm.controls['TabOne'].get('IsScrubberFitted').disable();
      this.circularRequestForm.controls['TabOne'].get('IsShipLoaded').disable();
      this.circularRequestForm.controls['TabOne'].get('MainEngineFuelId').disable();
      this.circularRequestForm.controls['TabOne'].get('DWT').disable();
      this.circularRequestForm.controls['TabOne'].get('CargoKind').disable();
      this.circularRequestForm.controls['TabOne'].get('CargoQuantity').disable();
    }

    this.clonedComponentDirectionId = this.rebateRequestLoaded.CircularsFixedRebateOptions[0].SailDirectionId;
    this.clonedComponentCircularId = this.rebateRequestLoaded.CircularsLookupId;
    if (this.rebateRequestLoaded.BaseRequest.StatusId == ServiceStatus.Circulars_NewRequest_EditedbyUser || this.rebateRequestLoaded.BaseRequest.StatusId == ServiceStatus.Circulars_NewRequest){
    this.circularRequestForm.controls['TabTwo'].patchValue({

      DateOfSailing: new Date(this.rebateRequestLoaded.DateOfSailing),
      ETASC: new Date(this.rebateRequestLoaded.ETASC),
      ETD: new Date(this.rebateRequestLoaded.ETD),
      SailDirectionId: this.rebateRequestLoaded.CircularsFixedRebateOptions[0].SailDirectionId,
      OriginRegionId: this.rebateRequestLoaded.CircularsFixedRebateOptions[0].FromRegionId,
      CircularsLookupId: this.rebateRequestLoaded.CircularsLookupId,
      Name: this.rebateRequestLoaded.Name,
      EMail: this.rebateRequestLoaded.EMail,
      Fax: this.rebateRequestLoaded.Fax
    });}
    else
    {
      this.circularRequestForm.controls['TabTwo'].patchValue({
        DateOfSailing: new Date(this.rebateRequestLoaded.DateOfSailing),
        ETASC: new Date(this.rebateRequestLoaded.ETASC),
        ETD: new Date(this.rebateRequestLoaded.ETD),
        SailDirectionId: this.rebateRequestLoaded.CircularsFixedRebateOptions[0].SailDirectionId,
        OriginRegionId: this.rebateRequestLoaded.CircularsFixedRebateOptions[0].FromRegionId,
        CircularsLookupId: this.rebateRequestLoaded.CircularsLookupId,
        Name: this.rebateRequestLoaded.Name,
        EMail: this.rebateRequestLoaded.EMail,
        Fax: this.rebateRequestLoaded.Fax
      });}
    this.globalServices.isLoaderEnabled = false;
  }
  mapRegionsKeys(index, OriginId, DestinationId, OriginPortId, DestinationPortId, otherLastPortOrigin, otherFirstPortDestination): void {
    if (DestinationPortId == "") {
      DestinationPortId = null;
    }
    let Origin: OptionKey = new OptionKey();
    Origin.Index = index;
    Origin.Value = OriginId;
    Origin.Text = this.FromRegions.filter(c => c.CircularsRegions.ID == OriginId)[0].CircularsRegions.NameEN;




   /* if (this.formMode == FormMode.New || this.formMode == FormMode.Edit ) {
      Origin.Text = this.FromRegions.filter(c => c.CircularsRegions.ID == OriginId)[0].CircularsRegions.NameEN;
    }
    else if ( this.formMode == FormMode.Details) {
      Origin.Text = this.FromRegions.filter(c => c.CircularsRegions.ID == OriginId)[0].CircularsRegions.NameEN;
    }*/
    Origin.Port = OriginPortId != -1 && OriginPortId != null ? this.ports.filter(c => c.Id == OriginPortId)[0].NameEN : otherLastPortOrigin;
    this.OriginsArr.push(Origin);

    let Destination: OptionKey = new OptionKey();
    Destination.Index = index;
    Destination.Value = DestinationId;
    this.ToRegions.forEach(element => {
      if(element.Id == DestinationId ){
        Destination.Text =  this.ToRegions.filter(c => c.Id == DestinationId)[0].CircularsRegions1.NameEN;
      }
      else if (element.CircularsRegions1.ID == DestinationId){
        Destination.Text = this.ToRegions.filter(c => c.CircularsRegions1.ID == DestinationId)[0].CircularsRegions1.NameEN;
      }
    });



   // Destination.Text = this.ToRegions.filter(c => c.Id == DestinationId)[0].CircularsRegions1.NameEN;
    Destination.Port = DestinationPortId != -1 && DestinationPortId != null ? this.ports.filter(c => c.Id == DestinationPortId)[0].NameEN : otherFirstPortDestination;
    this.distinationArr.push(Destination);
  }
  mapRssegionsKeys(index, lastCountryOriginId, firstCountryDestinationId, lastPortOriginId, firstPortDestinationId, otherLastPortOrigin, otherFirstPortDestination): void {
    //Last Country Origin Key
    let lastCountryOrigin: OptionKey = new OptionKey();
    lastCountryOrigin.Index = index;
    lastCountryOrigin.Value = lastCountryOriginId;

    lastCountryOrigin.Text = this.countries.filter(c => c.Id == lastCountryOrigin.Value)[0].NameEN;
    this.lastCountryOriginsArr.push(lastCountryOrigin);
    //First Country Destination Key
    let firstCountryDestination: OptionKey = new OptionKey();
    firstCountryDestination.Index = index;
    firstCountryDestination.Value = firstCountryDestinationId;
    firstCountryDestination.Text = this.countries.filter(c => c.Id == firstCountryDestination.Value)[0].NameEN;
    this.firstCountryDestinationsArr.push(firstCountryDestination);
    //Last Port Origin Key
    let lastPortOrigin: OptionKey = new OptionKey();
    lastPortOrigin.Index = index;
    lastPortOrigin.Value = lastPortOriginId;
    lastPortOrigin.Text = +lastPortOriginId != -1 && lastPortOriginId != null ? this.ports.filter(c => c.Id == lastPortOriginId)[0].NameEN : otherLastPortOrigin;
    this.lastPortOriginsArr.push(lastPortOrigin);
    //First Port Destination Key
    let firstPortDestination: OptionKey = new OptionKey();
    firstPortDestination.Index = index;
    firstPortDestination.Value = firstPortDestinationId;
    firstPortDestination.Text = +firstPortDestinationId != -1 && firstPortDestinationId != null ? this.ports.filter(c => c.Id == firstPortDestinationId)[0].NameEN : otherFirstPortDestination;
    this.firstPortDestinationsArr.push(firstPortDestination);
  }

  editRegionskeys(index, OriginId, DestinationId, OriginPortId, DestinationPortId, otherLastPortOrigin, otherFirstPortDestination): void {
    if (DestinationPortId == "") {
      DestinationPortId = null;
    }
    let Origin: OptionKey = this.OriginsArr[index];
    Origin.Value = OriginId;
    Origin.Text = this.FromRegions.filter(c => c.CircularsRegions.ID == OriginId)[0].CircularsRegions.NameEN;

    Origin.Port = OriginPortId != -1 && OriginPortId != null ? this.ports.filter(c => c.Id == OriginPortId)[0].NameEN : otherLastPortOrigin;
    let Destination: OptionKey = this.distinationArr[index];
    Destination.Value = DestinationId;
    Destination.Text =  this.ToRegions.filter(c => c.Id == DestinationId)[0].CircularsRegions1.NameEN;
   /* this.ToRegions.forEach(ele => {
      if(ele.Id == DestinationId ){
        Destination.Text =  this.ToRegions.filter(c => c.Id == DestinationId)[0].CircularsRegions1.NameEN;
      }
      else if (ele.CircularsRegions1.ID == DestinationId){
        Destination.Text = this.ToRegions.filter(c => c.CircularsRegions1.ID == DestinationId)[0].CircularsRegions1.NameEN;
      }
    });*/

    //Destination.Text = this.ToRegions.filter(c => c.Id == DestinationId)[0].CircularsRegions1.NameEN;
    Destination.Port = DestinationPortId != -1 && DestinationPortId != null ? this.ports.filter(c => c.Id == DestinationPortId)[0].NameEN : otherFirstPortDestination;
  }
  editMapCountriesKeys(index, lastCountryOriginId, firstCountryDestinationId, lastPortOriginId, firstPortDestinationId, otherLastPortOrigin, otherFirstPortDestination): void {
    //Last Country Origins Key
    let lastCountryOrigin: OptionKey = this.lastCountryOriginsArr[index];
    lastCountryOrigin.Value = lastCountryOriginId;
    lastCountryOrigin.Text = this.countries.filter(c => c.Id == lastCountryOrigin.Value)[0].NameEN;
    //First Country Destination Key
    let firstCountryDestination: OptionKey = this.firstCountryDestinationsArr[index];
    firstCountryDestination.Value = firstCountryDestinationId;
    firstCountryDestination.Text = this.countries.filter(c => c.Id == firstCountryDestination.Value)[0].NameEN;
    //Last Port Origin Key
    let lastPortOrigin: OptionKey = this.lastPortOriginsArr[index];
    lastPortOrigin.Index = index;
    lastPortOrigin.Value = lastPortOriginId;
    lastPortOrigin.Text = +lastPortOriginId != -1 && lastPortOriginId != null ? this.ports.filter(c => c.Id == lastPortOriginId)[0].NameEN : otherLastPortOrigin;
    this.lastPortOriginsArr.push(lastPortOrigin);
    //First Port Destination Key
    let firstPortDestination: OptionKey = this.firstPortDestinationsArr[index];
    firstPortDestination.Index = index;
    firstPortDestination.Value = firstPortDestinationId;
    firstPortDestination.Text = +firstPortDestinationId != -1 && firstPortDestinationId != null ? this.ports.filter(c => c.Id == firstPortDestinationId)[0].NameEN : otherFirstPortDestination;
    this.firstPortDestinationsArr.push(firstPortDestination);
  }
  navigateToParentRequestDetails(): void {
    localStorage.setItem('lsRebateRequestId', this.rebateRequestLoaded.BaseRequest.ParentRequestId);
    this.cookieService.set('RelatedRequestId',this.rebateRequestLoaded.BaseRequest.ParentRequestId);
    window.open('#/CircularRequest/BaseRequestDetails', '_blank');
  }

  onVesselConditionChange(value: string): void {

    if (value == "true") {
      this.showCargoWarning = false;
      (this.circularRequestForm.controls['TabOne'] as FormGroup).controls['CargoKind'].setValidators([Validators.required, Validators.pattern("[^=]+"), Validators.maxLength(200)]);
      (this.circularRequestForm.controls['TabOne'] as FormGroup).controls['CargoKind'].updateValueAndValidity();
      (this.circularRequestForm.controls['TabOne'] as FormGroup).controls['CargoQuantity'].setValidators([Validators.required, Validators.pattern("^[0-9]{1,6}$"), Validators.maxLength(200)]);
      (this.circularRequestForm.controls['TabOne'] as FormGroup).controls['CargoQuantity'].updateValueAndValidity();
    } else {
      this.showCargoWarning = false;
      (this.circularRequestForm.controls['TabOne'] as FormGroup).controls['CargoKind'].reset();
      (this.circularRequestForm.controls['TabOne'] as FormGroup).controls['CargoKind'].clearValidators();
      (this.circularRequestForm.controls['TabOne'] as FormGroup).controls['CargoKind'].updateValueAndValidity();
      (this.circularRequestForm.controls['TabOne'] as FormGroup).controls['CargoQuantity'].reset();
      (this.circularRequestForm.controls['TabOne'] as FormGroup).controls['CargoQuantity'].clearValidators();
      (this.circularRequestForm.controls['TabOne'] as FormGroup).controls['CargoQuantity'].updateValueAndValidity();
    }
  }
  navigateToCloneRequest(): void {
    this.route.navigate(['CircularRequest/CloneRequest'], { state: { data: { requestId: this.rebateRequestId, ParentCreationDate: this.rebateRequestCreationDate } } });
  }

  reloadComponent(): void {
    window.location.reload();
  }
  setDateTimeDefault() {
    var defaultTimeForDates = ",12:00:00 PM";
    this.circularRequestObject.LastTransitDate = this.circularRequestObject.LastTransitDate != null && this.circularRequestObject.LastTransitDate != "" ? new Date(this.circularRequestObject.LastTransitDate.toLocaleDateString() + defaultTimeForDates) : null;
    this.circularRequestObject.DateOfSailing = new Date(this.circularRequestObject.DateOfSailing.toLocaleDateString() + defaultTimeForDates);
    this.circularRequestObject.ETASC = new Date(this.circularRequestObject.ETASC.toLocaleDateString() + defaultTimeForDates);
    this.circularRequestObject.ETD = this.circularRequestObject.ETD != null && this.circularRequestObject.ETD != "" ?new Date(this.circularRequestObject.ETD.toLocaleDateString() + defaultTimeForDates): null;
    /*this.circularRequestObject.CircularsFixedRebateOptions.forEach(function (option) {
      option.DateOfSailing = new Date(option.DateOfSailing.toLocaleDateString() + defaultTimeForDates);
      option.ETASC = new Date(option.ETASC.toLocaleDateString() + defaultTimeForDates);
    });*/
  }
  exportFax(e): void {
    e.preventDefault();
    this.exportFaxdata();

  }
  exportFaxdata(){
    let Background = SCAWaterMark.Background;
    let Direction;
    let ETA;
    let DateOfSailing;
    var options = [];

    this.rebateRequestLoaded.CircularsFixedRebateOptions.forEach(element => {
      let portoforigin = "";
      let portofdestination = "";
      let OriginRegion;
      let distRegion;
      let Countryforigin = "";
      let Countrydestination = "";
      let RebatePercentage = "";
      let DateOfSailing;
      OriginRegion = this.ToRegions.filter(c => c.Id == element.CircularsPercentagesId)[0].CircularsRegions.NameEN ;
      distRegion = this.ToRegions.filter(c => c.Id == element.CircularsPercentagesId)[0].CircularsRegions1.NameEN;
      RebatePercentage = this.TempToRegions.filter(c => c.Id == element.CircularsPercentagesId)[0].PercentageValue;
      if (element.LastPortOriginId != null && element.LastPortOriginId != -1) {
        portoforigin = this.ports.filter(c => c.Id == Number(element.LastPortOriginId))[0].NameEN + " - ";
      }
      else {
        portoforigin = element.OtherLastPortOrigin + " - ";
      }

      if (element.FirstPortDestinationId != null && element.FirstPortDestinationId != -1) {
        portofdestination = this.ports.filter(c => c.Id == Number(element.FirstPortDestinationId))[0].NameEN + " - ";
      }
      else {
        portofdestination = element.OtherFirstPortDestination + " - ";
      }
      Countryforigin = element.LastCountryOriginId != null ? this.countries.filter(c => c.Id == Number(element.LastCountryOriginId))[0].NameEN + " - " : " - ";
      Countrydestination = element.FirstCountryDestinationId != null ? this.countries.filter(c => c.Id == Number(element.FirstCountryDestinationId))[0].NameEN + " - " : " - ";
      let requestorigin = portoforigin + Countryforigin + OriginRegion;
      let requestdist = portofdestination + Countrydestination + distRegion;




      let option =
        [{
          alignment: 'left',
          style: 'options',
          columns: [

            {
              text: requestorigin,
            },
            {
              text: '  '
            },
            {
              text: requestdist,
            },
            {
              text: '  '
            },
            {
              text: RebatePercentage,
            }
          ]
        },
        {
          alignment: 'left',
          style: 'options',
          columns: [

            {
              text: ' ',
            },
            {
              text: '   ',
            },
            {
              text: ' ',
            },
            {
              text: '   ',
            },
            {
              text: ' ',
            }
          ]
        }

        ]
      options.push(option);
    });

    let SCID= '';
    if(this.rebateRequestLoaded.AdminSCID == '' || this.rebateRequestLoaded.AdminSCID == null)
    {
      SCID = this.rebateRequestLoaded.SCID;
    }
    else
    {
      SCID = this.rebateRequestLoaded.AdminSCID;
    }
    if (this.rebateRequestLoaded.DateOfSailing.includes('T')) {
     // DateOfSailing = this.datepipe.transform(this.rebateRequestLoaded.DateOfSailing.split("T")[0], 'dd-MM-yyyy');
      ETA = this.datepipe.transform(this.rebateRequestLoaded.ETASC.split("T")[0], 'dd-MM-yyyy');
      //ETA = this.datepipe.transform(element.ETA.split("T")[0], 'dd-MM-yyyy');
    }
    else {
      ETA = this.rebateRequestLoaded.ETASC;
      //DateOfSailing = rebateRequestLoaded.DateOfSailing;
    }
    if (this.rebateRequestLoaded.CircularsFixedRebateOptions[0].SailDirectionId == 2) {
      Direction = "Port Tawfik Admeasurement";
    }
    else if (this.rebateRequestLoaded.CircularsFixedRebateOptions[0].SailDirectionId == 3) {
      Direction = "Port Said Admeasurement";
    }
    else {
      Direction = "";
    }
     let directorName = this.translate.instant('SHARED.DirectorName');
    let docDefinition = {
      background: function (currentPage, pageCount, pageSize) {
        return [
          {
            image: Background,
            opacity: 0.9,
            fit: [600, 845]
          },
        ]
      },

      content: [
        {
          text: 'MEMO',
          style: 'headerCenter',
          decoration: 'underline',
        },
        {
          text: '\n',
        },
        {
          text: 'No.   : ..............................',
        },
        {
          text: 'Re.   : ..............................',
        },
        {
          text: '\n',
        },
        {
          style: 'FromTo',
          alignment: 'left',
          columns: [

            { text: 'From: Admeasurement Control'},
            { text: '  ' },
            { text: 'To: ' + Direction },
          ]
        },

        {
          text: '_______________________________________________________________________________________________',
        },
        {
          text: '\n',
        },
        {

          alignment: 'left',
          columns: [

            { text: 'Vessel Name: '    , style:'columnheader'},

            { text: this.rebateRequestLoaded.VesselName, style:'columndata' },
          ]
        },
        {
          text: '\n',
        },

        {

          alignment: 'left',
          columns: [

            { text: 'IMO No: '    , style:'columnheader'},

            { text: this.rebateRequestLoaded.IMONo, style:'columndata' },
          ]
        },
        {
          text: '\n',
        },
        {

          alignment: 'left',
          columns: [

            { text: 'SCID: '    , style:'columnheader'},

            { text: SCID, style:'columndata' },
          ]
        },
        {
          text: '\n',
        },
        {

          alignment: 'left',
          columns: [

            { text: 'Repate File No.: '    , style:'columnheader'},

            { text: this.rebateRequestLoaded.RebateFileNumber, style:'columndata' },
          ]
        },
        {
          text: '\n',
        },
        {

          alignment: 'left',
          columns: [

            { text: 'ETA: '    , style:'columnheader'},

            { text: ETA, style:'columndata' },
          ]
        },
        {
          text: '\n',

        },
        {
          text: '_______________________________________________________________________________________________',
        },
        {
          text: '\n',
        },
        {
          alignment: 'left',
          style: 'optionsheader',
          columns: [

            {
              text: 'FROM: ',
            },
            {
              text: ' ',
            },
            {
              text: 'TO: ',
            },
            {
              text: ' ',
            },
            {
              text: '% ',
            }
          ]
        },
        {
          alignment: 'left',
          style: 'optionsheader',
          columns: [

            {
              text: ' ',
            },
            {
              text: ' ',
            },
            {
              text: ' ',
            },
            {
              text: ' ',
            },
            {
              text: ' ',
            }

          ]
        },
        options,
        {
          text: '_______________________________________________________________________________________________',
        },
        {
          text: '\n',
        },
        {
          style:'note',
          text: 'According to circular no. '+ this.rebateRequestLoaded.CircularsLookup.CircularNo + ' and its amendments and renewal periodicals.',
        },
        {
          text: '\n',
        },
        {
          style:'note',
          text: 'Please submit the following: ',
        },
        {
          style:'note',
          text: '            -   Masters declaration',
        },
        {
          style:'note',
          text: '            -   Ports of call list',
        },
        {
          style:'note',
          text: '            -   Cargo manifest',
        },
        {
          style:'footer',
          text: 'Deputy Director of transit department',
        },
        {
          style:'footer',
          text: 'Head of admeasurement control sec',
        },
        {
          text: '\n',
        },
        {
          style:'footer',
          text: directorName,
        },
      ],
      styles: {
        note:{
          fontSize: 12,
        },
        columnheader:{
          fontSize: 12,
          bold: true,
        },
        columndata:{
          fontSize: 12,
          bold: false,
        },
        headerCenter:{
          alignment: "center",
          fontSize: 26,
          bold: true,
        },
        notFromToe: {
          fontSize: 15,
          bold: true,
        },
        MV1: {
          fontSize: 26,
          bold: true,
        },
        right: {
          alignment: "right"
        },
        img: {
          alignment: "center"
        },
        header: {
          fontSize: 30,
          bold: true,
          margin: [0, 0, 0, 5]
        },
        subheader: {
          fontSize: 17,
          bold: false,
          margin: [0, 10, 0, 5]
        },
        MV: {
          fontSize: 42,
          bold: true,
          alignment: 'center'
        },
        LT: {
          fontSize: 12,
          bold: false,
          alignment: 'center'
        },
        center: {
          fontSize: 40,
          bold: true,
          alignment: 'center'
        },
        ex: {
          fontSize: 14,
          bold: true,
          alignment: 'center'
        },
        footer: {
          alignment: 'right',
          fontSize: 12,
        },
        optionsheader: {
          bold: true,
          fontSize: 14,
          alignment: 'left'
        },
        options: {
          bold: false,
          fontSize: 10,
          alignment: 'left'
        },
        tableHeader: {
          bold: true,
          fontSize: 13,
          color: 'black'
        }
      }
    }

    pdfMake.createPdf(docDefinition).open();
  }







  exportAgentPdf(e): void {
    e.preventDefault();
    this.exportAgentpdf();
  }
  exportcover(e): void {
    e.preventDefault();
    this.exportCoverTOpdf();

  }
  exportdata() {
    this.exportdataTOpdf();
  }
  exportdataTOpdf(): void {
    let Background = SCAWaterMark.Background;
    let vesselTypeName;
    let SCID;
    let ExName = "";
    let isSub = false;
    let subsection = [];

    if (this.rebateRequestLoaded.ParentRequestNumber != null && this.rebateRequestLoaded.ParentRequestNumber != "" && this.ParentCreationDateForSubRequest != null) {
      isSub = true;
      let subinfo = {
        style: 'tableExample',
        table: {
          body: [
            ["Is Sub-Request", "ParentNumber", "Parent Creation Date"],
            [isSub, this.rebateRequestLoaded.ParentRequestNumber, this.datepipe.transform(this.ParentCreationDateForSubRequest, 'dd/MM/yyyy H:mm:ss') + " GMT+2"]
          ]
        }
      }
      subsection.push(subinfo);
    }

    let vesselType = this.vesselTypes.filter(v => v.VesselTypeId == this.rebateRequestLoaded.VesselTypeId)
    vesselTypeName = vesselType[0].NameEN;


    if (this.rebateRequestLoaded.AdminExNames == null) {
      ExName = this.rebateRequestLoaded.ExNames;
    }
    else {
      ExName = this.rebateRequestLoaded.AdminExNames;
    }
    SCID = this.rebateRequestLoaded.AdminSCID;
    //SCID = this.rebateRequestLoaded.AdminSCID;



    let loadedballast = ""

    if (this.rebateRequestLoaded.IsShipLoaded == true) {
      loadedballast = "Loaded"
    }
    else {
      loadedballast = "Ballast"
    }

    var options = [];

    this.rebateRequestLoaded.CircularsFixedRebateOptions.forEach(element => {

      let portoforigin = "";
      let portofdestination = "";

      let OriginRegion;
      let distRegion;

      let DateOfSailing;
      let ETA;
      let RebatePercentage = ""
      this.ToRegions.forEach(el => {
        if(el.Id == element.CircularsPercentagesId ){
          OriginRegion = this.ToRegions.filter(c => c.Id == element.CircularsPercentagesId)[0].CircularsRegions.NameEN;
          distRegion = this.ToRegions.filter(c => c.Id == element.CircularsPercentagesId)[0].CircularsRegions1.NameEN;
        }
      });
      this.TempToRegions.forEach(el => {
        if(el.Id == element.CircularsPercentagesId ){
          RebatePercentage =  this.TempToRegions.filter(c => c.Id == element.CircularsPercentagesId)[0].PercentageValue + ' %';
        }
      });
      //OriginRegion = this.ToRegions.filter(c => c.Id == element.CircularsPercentagesId)[0].CircularsRegions.NameEN;
      //distRegion = this.ToRegions.filter(c => c.Id == element.CircularsPercentagesId)[0].CircularsRegions1.NameEN;
      // if(element.isGranted){
      /*}
       else
       {
         RebatePercentage = "--"
       }*/

      if (element.LastPortOriginId != null && element.LastPortOriginId != -1) {
        portoforigin = this.ports.filter(c => c.Id == Number(element.LastPortOriginId))[0].NameEN;
      }
      else {
        portoforigin = element.OtherLastPortOrigin;
      }

      if (element.FirstPortDestinationId != null && element.FirstPortDestinationId != -1) {
        portofdestination = this.ports.filter(c => c.Id == Number(element.FirstPortDestinationId))[0].NameEN;
      }
      else {
        portofdestination = element.OtherFirstPortDestination;
      }


      let Countryforigin = element.LastCountryOriginId != null ? this.countries.filter(c => c.Id == Number(element.LastCountryOriginId))[0].NameEN + " - " : " - ";
      let Countrydestination = element.FirstCountryDestinationId != null ? this.countries.filter(c => c.Id == Number(element.FirstCountryDestinationId))[0].NameEN + " - " : " - ";


      let requestorigin = portoforigin + ' - ' + Countryforigin + OriginRegion;
      let requestdist = portofdestination + ' - '+ Countrydestination + distRegion;


      if (this.rebateRequestLoaded.DateOfSailing.includes('T')) {
        DateOfSailing = this.datepipe.transform(this.rebateRequestLoaded.DateOfSailing.split("T")[0], 'dd-MM-yyyy');
        //ETA = this.datepipe.transform(element.ETA.split("T")[0], 'dd-MM-yyyy');
      }
      else {
        DateOfSailing = this.rebateRequestLoaded.DateOfSailing;
        // ETA = element.ETA;
      }

      let option = {
        style: 'tableExample',
        table: {
          body: [
            ['Origin:', 'Destination:', " Rebate %:", "Sailing Date:"],
            [requestorigin, requestdist, RebatePercentage, DateOfSailing,]
          ]
        }
      }
      options.push(option);
    });




    let docDefinition = {

      header: 'Circulars Service',
      content: [
        subsection,
        { text: 'Agent Info', color: '#7f0909', style: 'sectionHeader' },
        {
          style: 'tableExample',
          table: {
            body: [
              ['Agent Name:', "Principal Name", "Principal FAX"],
              [this.rebateRequestLoaded.BaseRequest.RequestorName, this.rebateRequestLoaded.Name, this.rebateRequestLoaded.Fax]
            ]
          }
        },
        { text: 'Rebate Request Summary', color: '#7f0909', style: 'sectionHeader' },
        {
          style: 'tableExample',
          table: {
            body: [
              ['Request Number:', 'Submission Date:', 'File Number:', 'Decision feedback Date:'],
              [this.rebateRequestLoaded.BaseRequest.RequestNumber, this.datepipe.transform(this.rebateRequestLoaded.BaseRequest.CreationDate, 'dd/MM/yyyy H:mm'), this.rebateRequestLoaded.RebateFileNumber, this.datepipe.transform(this.rebateRequestLoaded.DecisionDate, 'dd/MM/yyyy H:mm')]
            ]
          }
        }
        ,
        { text: 'Vessel Particulars', color: '#7f0909', style: 'sectionHeader' },
        ,
        {
          style: 'tableExample',
          table: {
            body: [
              ['Vessel Name:', 'SCID:', 'IMO Number:', 'Ex Names:', 'Vessel Type:'],
              [this.rebateRequestLoaded.VesselName, SCID, this.rebateRequestLoaded.IMONo, ExName, vesselTypeName]
            ]
          }
        },
        {
          style: 'tableExample',
          table: {
            body: [
              ['Loaded/Ballast:', 'Cargo Kind:', 'Agent Naotes:'],
              [loadedballast, this.rebateRequestLoaded.CargoKind, this.rebateRequestLoaded.Note]
            ]
          }
        },
        {
          style: 'tableExample',
          table: {
            body: [
              ['SCNT:', 'DWT:',],
              [this.rebateRequestLoaded.SCNT, this.rebateRequestLoaded.DWT]
            ]
          }
        },

        { text: 'Options:', color: '#7f0909', style: 'sectionHeader' },
        options,

      ],
      styles: {
        header: {
          fontSize: 18,
          bold: true,
          margin: [0, 0, 0, 10]
        },
        subheader: {
          fontSize: 16,
          bold: true,
          margin: [0, 10, 0, 5]
        },
        tableExample: {
          margin: [0, 5, 0, 15],
          fontSize: 12,
          alignment: 'left'
        },
        tableHeader: {
          bold: true,
          fontSize: 13,
          color: 'black'
        }
      }
    }

    pdfMake.createPdf(docDefinition).open();
    //this.exportCoverTOpdf();
  }



  exportCoverTOpdf(): void {
    let vesselTypeName;
    let Background = SCAWaterMark.Background;
    var options = [];
    var table;
    let GrantingDate = this.rebateRequestLoaded.DecisionDate;
    let ETA;
    let DateOfSailing;
    this.rebateRequestLoaded.CircularsFixedRebateOptions.forEach(element => {
      let portoforigin = "";
      let portofdestination = "";
      let OriginRegion;
      let distRegion;
      let Countryforigin = "";
      let Countrydestination = "";
      let RebatePercentage = "";

      OriginRegion = this.ToRegions.filter(c => c.Id == element.CircularsPercentagesId)[0].CircularsRegions.NameEN;
      distRegion = this.ToRegions.filter(c => c.Id == element.CircularsPercentagesId)[0].CircularsRegions1.NameEN;
      RebatePercentage = this.TempToRegions.filter(c => c.Id == element.CircularsPercentagesId)[0].PercentageValue;
      if (element.LastPortOriginId != null && element.LastPortOriginId != -1) {
        portoforigin = this.ports.filter(c => c.Id == Number(element.LastPortOriginId))[0].NameEN + " - ";
      }
      else {
        portoforigin = element.OtherLastPortOrigin + " - ";
      }

      if (element.FirstPortDestinationId != null && element.FirstPortDestinationId != -1) {
        portofdestination = this.ports.filter(c => c.Id == Number(element.FirstPortDestinationId))[0].NameEN + " - ";
      }
      else {
        portofdestination = element.OtherFirstPortDestination + " - ";
      }
      Countryforigin = element.LastCountryOriginId != null ? this.countries.filter(c => c.Id == Number(element.LastCountryOriginId))[0].NameEN + " - " : " - ";
      Countrydestination = element.FirstCountryDestinationId != null ? this.countries.filter(c => c.Id == Number(element.FirstCountryDestinationId))[0].NameEN + " - " : " - ";
      let requestorigin = portoforigin + Countryforigin + OriginRegion;
      let requestdist = portofdestination + Countrydestination + distRegion;

      if (this.rebateRequestLoaded.DateOfSailing.includes('T')) {
        DateOfSailing = this.datepipe.transform(this.rebateRequestLoaded.DateOfSailing.split("T")[0], 'dd-MM-yyyy');
        ETA = this.datepipe.transform(this.rebateRequestLoaded.ETASC.split("T")[0], 'dd-MM-yyyy');
      }
      else {
        DateOfSailing = this.rebateRequestLoaded.DateOfSailing;
        ETA = this.rebateRequestLoaded.ETD;
      }

      let option =
        [{
          alignment: 'left',
          style: 'options',
          columns: [
            {
              text: ' ',
            },
            {
              text: requestorigin,
              width: 200,
            },
            {
              text: '  '
            },
            {
              text: requestdist,
              width: 200,
            },
            {
              text: '  '
            },
            {
              text: RebatePercentage,
              width: 50,
               bold: true,
            }
          ]
        },
        {
          alignment: 'left',
          style: 'options',
          columns: [
            {
              text: ' ',
            },
            {
              text: ' ',
            },
            {
              text: '   ',
            },
            {
              text: ' ',
            },
            {
              text: '   ',
            },
            {
              text: ' ',
            }
          ]
        }

        ]
      options.push(option);

    });

    let ParentNumber = '';
    let Direction = "";
    let SCID = "";
    let ex = "";
    let LTD = ""
    if(this.rebateRequestLoaded.ParentRequestNumber != null && this.rebateRequestLoaded.ParentRequestNumber !="" && this.ParentCreationDateForSubRequest!= null)
    {
      ParentNumber = 'Parent Number: ' + this.rebateRequestLoaded.ParentRequestNumber +  ' - ' + this.datepipe.transform(this.ParentCreationDateForSubRequest, 'dd/MM/yyyy');
    }
    let CreationDate = this.datepipe.transform(this.rebateRequestLoaded.CreationDate, 'dd/MM/yyyy');
    if (this.rebateRequestLoaded.LastTransitDate != null) {
      LTD = this.datepipe.transform(this.rebateRequestLoaded.LastTransitDate, 'dd/MM/yyyy');
    }
    else {
      LTD = "None"
    }
    if (this.rebateRequestLoaded.AdminSCID != null) {
      SCID = this.rebateRequestLoaded.AdminSCID;
    }
    else {
      SCID = "";
    }
    if (this.rebateRequestLoaded.AdminExNames == null) {
      ex = this.rebateRequestLoaded.ExNames;
    }
    else {
      ex = this.rebateRequestLoaded.AdminExNames;
    }

    if (this.rebateRequestLoaded.CircularsFixedRebateOptions[0].SailDirectionId == 2) {
      Direction = "Northbound";
    }
    else if (this.rebateRequestLoaded.CircularsFixedRebateOptions[0].SailDirectionId == 3) {
      Direction = "Southbound";
    }
    else {
      Direction = "";
    }
    if (this.rebateRequestLoaded.VesselTypeId != 0  ) {
      let vesselType = this.vesselTypes.filter(v => v.VesselTypeId == this.rebateRequestLoaded.VesselTypeId)
      vesselTypeName = vesselType[0].NameEN;
    }
    else {
      vesselTypeName = "0";
    }

    let loadedballast = ""
    if (this.rebateRequestLoaded.IsShipLoaded == true) {
      loadedballast = "Loaded"
    }
    else {
      loadedballast = "Ballast"
    }

    let docDefinition = {
      background: function (currentPage, pageCount, pageSize) {
        return [
          {
            image: Background,
            //height: 845,
            //width:600,
            opacity: 0.9,
            fit: [600, 845]
          },
        ]
      },
      content: [
        {
          text: this.rebateRequestLoaded.RebateFileNumber,
          style: 'header'
        },
        {
          text: Direction,
          style: 'subheader'
        },
        {
          alignment: 'left',
          style: 'exe',
          columns: [
            {
              text: this.rebateRequestLoaded.BaseRequest.RequestorName ,
            },
            {
              text: '   '
            },

            {
              text: "Principal :  "+ this.rebateRequestLoaded.Name,
            }
          ]
        },
        {
          alignment: 'left',
          style: 'exe',
          columns: [
            {
              text: 'Agent Fax : '+ this.agentFax,
            },
            {
              text: '   '
            },
            {
              text: "Fax :  "+ this.rebateRequestLoaded.Fax + '\n ',
            }
          ]
        },
        {
          alignment: 'left',
          style: 'exe',
          columns: [
            {
              text: 'Request No. : '+ this.rebateRequestLoaded.BaseRequest.RequestNumber,
            },
            {
              text: '   '
            },
            {
              text: ParentNumber,
            }
          ]
        },
        {
          text: "Mv:  "+ this.rebateRequestLoaded.VesselName,
          style: 'MV'
        },
        {
          alignment: 'center',
          style: 'ex',
          columns: [
            {
              text: '\n EX Name:' + ex + "\n ",
            },

          ]
        },
        {
          text: "Last Transit Date:  " + LTD,
          style: 'LT'
        },

        {
          alignment: 'center',
          style: 'ex',
          columns: [
            {
              text: 'SCID: ' + SCID,
            },
            {
              text: 'IMO: ' + this.rebateRequestLoaded.IMONo + "\n \n \n \n",
            }
          ]
        },
        {
          alignment: 'left',
          style: 'optionsheader',
          columns: [
            {
              text: ' ',
            },
            {
              text: 'FROM: ',
              width: 200,
            },
            {
              text: ' ',
            },
            {
              text: 'TO: ',
              width: 200,
            },
            {
              text: ' ',
            },
            {
              text: '% ',
              width: 50,
            }
          ]
        },
        {
          alignment: 'left',
          style: 'optionsheader',
          columns: [
            {
              text: ' ',
            },
            {
              text: ' ',
            },
            {
              text: ' ',
            },
            {
              text: ' ',
            },
            {
              text: ' ',
            },
            {
              text: ' ',
            }

          ]
        },
        options,
        {
          text: "\n",
          style: 'subheader'
        },
        {
          style: 'tableExample',
          table: {
            body: [
              ['Submission Date','Rebate Granting Date', 'Sailing Date' , 'ETA'],
              [this.datepipe.transform(this.rebateRequestLoaded.BaseRequest.CreationDate, 'dd/MM/yyyy'),this.datepipe.transform(GrantingDate, 'dd/MM/yyyy') , DateOfSailing ,ETA]
            ]
          }
        },
        {
          text: "\n",
          style: 'subheader'
        },
        {
          style: 'tableExample',
          table: {
            body: [
              ['Vessel Type','Loaded/Ballast:','Cargo Kind', 'Agent Notes'],
              [vesselTypeName,loadedballast , this.rebateRequestLoaded.CargoKind,this.rebateRequestLoaded.Note ]
            ]
          }
        },
        {
          text: "\n",
          style: 'subheader'
        },
        /*{
          alignment: 'left',
          style: 'ex',
          columns: [
            {
              text: 'ETA',
            },
            {
              text: ETA,
            }
          ]
        },*/
        {
          text: "\n \n",
          style: 'subheader'
        },
        {
          text: "",
          style: 'footer'
        },
        {
          text: "",
          style: 'footer'
        },
      ],
      styles: {
        header: {
          fontSize: 26,
          bold: true,
          margin: [0, 0, 0, 5]
        },
        subheader: {
          fontSize: 17,
          bold: false,
          margin: [0, 10, 0, 5]
        },
        MV: {
          fontSize: 38,
          bold: true,
          alignment: 'center'
        },
        LT: {
          fontSize: 12,
          bold: false,
          alignment: 'center'
        },
        center: {
          fontSize: 36,
          bold: true,
          alignment: 'center'
        },
        exe: {
          fontSize: 11,
          bold: false,
          alignment: 'center'
        },
        ex: {
          fontSize: 11,
          bold: true,
          alignment: 'center'
        },
        footer: {
          fontSize: 14,
        },
        optionsheader: {
          bold: true,
          fontSize: 16,
          alignment: 'left'
        },
        options: {
          bold: false,
          fontSize: 12,
          alignment: 'left'
        },
        tableHeader: {
          bold: true,
          fontSize: 13,
          color: 'black'
        }
      }
    }

    pdfMake.createPdf(docDefinition).open();
  }
  exportAgentpdf(): void {
    let Background = SCAWaterMark.Background;
    let logo = Logo.logo;
    var options = [];
    let requestorigin = "";
    this.rebateRequestLoaded.CircularsFixedRebateOptions.forEach(element => {


      let portoforigin = "";
      let portofdestination = "";

      let OriginRegion;
      let distRegion;

      let Countryforigin = "";
      let Countrydestination = "";
      let RebatePercentage = "";



          distRegion = this.ToRegions.filter(c => c.Id == element.CircularsPercentagesId)[0].CircularsRegions1.NameEN;





          OriginRegion = this.FromRegions.filter(c => c.Id == element.CircularsPercentagesId)[0].CircularsRegions.NameEN;


      //OriginRegion = this.FromRegions.filter(c => c.Id == element.CircularsPercentagesId)[0].CircularsRegions.NameEN;
      //distRegion = this.ToRegions.filter(c => c.Id == element.CircularsPercentagesId)[0].CircularsRegions1.NameEN;
      if (element.isGranted) {
        RebatePercentage = this.Percentages.filter(c => c.Id == element.CircularsPercentagesId)[0].PercentageValue + ' %';
      }
      else {
        RebatePercentage = "--"
      }

      if (element.LastPortOriginId != null && element.LastPortOriginId != -1) {
        portoforigin = this.ports.filter(c => c.Id == Number(element.LastPortOriginId))[0].NameEN + " - ";
      }
      else {
        portoforigin = element.OtherLastPortOrigin + " - ";
      }

      if (element.FirstPortDestinationId != null && element.FirstPortDestinationId != -1) {
        portofdestination = this.ports.filter(c => c.Id == Number(element.FirstPortDestinationId))[0].NameEN + " - ";
      }
      else {
        portofdestination = element.OtherFirstPortDestination + " - ";
      }
      // Countryforigin = element.LastCountryOriginId != null ? this.countries.filter(c => c.Id == Number(element.LastCountryOriginId))[0].NameEN : "";
      // Countrydestination = element.FirstCountryDestinationId != null ? this.countries.filter(c => c.Id == Number(element.FirstCountryDestinationId))[0].NameEN : "";
      requestorigin = portoforigin + OriginRegion;
      let requestdist = portofdestination + distRegion;

      let ETA;
      let DateOfSailing;
      if (this.rebateRequestLoaded.DateOfSailing.includes('T')) {
        DateOfSailing = this.datepipe.transform(this.rebateRequestLoaded.DateOfSailing.split("T")[0], 'dd-MM-yyyy');
        ETA = this.datepipe.transform(this.rebateRequestLoaded.ETASC.split("T")[0], 'dd-MM-yyyy');
      }
      else {

        ETA = this.rebateRequestLoaded.ETD;
        DateOfSailing = this.rebateRequestLoaded.DateOfSailing;
      }

      let option =
        [{
          alignment: 'left',
          style: 'options',
          columns: [

            {
              text: requestdist,
            },
            {
              text: '',
            },
            {
              text: RebatePercentage,
            }
          ]
        },
        {
          alignment: 'center',
          style: 'optionss',
          columns: [

            {
              text: ' ',
            },

            {
              text: ' ',
            },
            {
              text: ' ',
            }
          ]
        }

        ]
      options.push(option);
    });
    let LadenBallast = "";
    if (this.rebateRequestLoaded.IsShipLoaded) {
      LadenBallast = "Laden"
    }
    else {
      LadenBallast = "Ballast"
    };
    let DecisionDate = "";
    if (this.rebateRequestLoaded.DecisionDate == null) {
      DecisionDate = "";
    }
    else {
      DecisionDate = this.datepipe.transform(this.rebateRequestLoaded.DecisionDate.split("T")[0], 'dd/MM/yyyy');
    }
    let CreationDate = this.datepipe.transform(this.rebateRequestLoaded.CreationDate.split("T")[0], 'dd/MM/yyyy');
    let docDefinition = {
      background: function (currentPage, pageCount, pageSize) {
        return [
          {
            image: Background,
            //height: 845,
            //width:600,
            opacity: 0.9,
            fit: [600, 845]
          },
        ]
      },

      content: [
        {
          alignment: 'left',
          columns: [
            {
              text: 'ARAB REPUBLIC OF EGYPT \n Suez canal Authority \n www.suezcanal.gov.eg ', style: 'sectionHeader'
            },
            {
              image: logo,
              width: 100,
              height: 100,
              style: 'img'
            },
            {
              text: '', style: 'sectionHeader'
            }

          ]
        },
        { text: '----------------------------------------------------------------------------------------------------------------------------------------------------------', },
        { text: '\n', },
        {
          alignment: 'left',
          columns: [
            {
              text: 'To:   ' + this.rebateRequestLoaded.BaseRequest.RequestorName, style: 'sectionHeader'
            },
            {

            },
            {
              text: 'Fax No.:   ' + this.rebateRequestLoaded.Fax, style: 'sectionHeader'
            }

          ]
        }
        ,
        /*{
          alignment: 'left',
          columns: [
            {
              text: 'CC:  -------------------------------------------------------------------------------------------------------------------------------------------------------- ', style: 'sectionHeader'
            },
            {

            },
            {

            }

          ]
        }*/
        { text: '\n', },
        {
          alignment: 'left',
          columns: [
            {
              text: 'In Reply, PLS Mention:', style: 'sectionHeader'
            },
            {

            },
            {
              text: 'File No.:   ' + this.rebateRequestLoaded.RebateFileNumber, style: 'sectionHeader'
            }

          ]
        },


        { text: '\n', },
        { text: '______________________________________________________________________________________________' },
        { text: '\n', },
        { text: 'MV :  ' + this.rebateRequestLoaded.VesselName, style: 'MV1' },
        { text: '\n', },
        { text: '______________________________________________________________________________________________' },
        { text: '\n', },
        { text: 'YRS DATED :       ' + CreationDate + '                 Request Status : ' + this.rebateRequestLoaded.BaseRequest.StatusEN, style: 'sectionHeader' },
        { text: '\n', },
        { text: 'For her ( ' + LadenBallast + ' ) trip.', style: 'sectionHeader' },
        { text: '\n', },
        { text: 'From :  ' + requestorigin, style: 'sectionHeader' },
        { text: '\n', },
        { text: '\n', },
        { text: 'To  : ', style: 'sectionHeader' },
        { text: '\n', },
        options,
        { text: '\n', },
        { text: '\n', },
        { text: 'The vessel will be granted the above rebate from S.C normal tolls, subject to fulfilling Circ. ' + this.rebateRequestLoaded.CircularsLookup.CircularNo + ' conditions and supplementary periodicals concerning renewal or amendments of it.', style: 'note' },
        { text: '\n', },
        { text: '\n', },
        { text: '\n', },
        { text: '\n', },

        { text: '\n', },
        {
          alignment: 'left',
          columns: [
            {
              text: 'Best Regards', style: 'left',

            },
            {
              text: '', style: 'left',

            },
            {
              text: 'SUCAN \n ' + DecisionDate, style: 'left',

            }
          ]
        }
      ],
      styles: {
        note: {
          fontSize: 12,
          bold: true,
        },
        MV1: {
          fontSize: 26,
          bold: true,
        },
        right: {
          alignment: "right"
        },
        img: {
          alignment: "center"
        },
        header: {
          fontSize: 30,
          bold: true,
          margin: [0, 0, 0, 5]
        },
        subheader: {
          fontSize: 17,
          bold: false,
          margin: [0, 10, 0, 5]
        },
        MV: {
          fontSize: 42,
          bold: true,
          alignment: 'center'
        },
        LT: {
          fontSize: 12,
          bold: false,
          alignment: 'center'
        },
        center: {
          fontSize: 40,
          bold: true,
          alignment: 'center'
        },
        ex: {
          fontSize: 14,
          bold: true,
          alignment: 'center'
        },
        footer: {
          fontSize: 14,
        },
        optionsheader: {
          bold: true,
          fontSize: 16,
          alignment: 'left'
        },
        options: {
          bold: false,
          fontSize: 12,
          alignment: 'left'
        },
        tableHeader: {
          bold: true,
          fontSize: 13,
          color: 'black'
        }
      }
    }

    pdfMake.createPdf(docDefinition).open();
  }
}

enum FormMode {
  New = 1,
  Edit = 2,
  Details = 3
}

enum ConfirmationMode {
  Success = 1,
  Error = 2
}
